import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import BaseUrl from '../../ApiServices/BaseUrl';
import {
  FaUser, FaBuilding, FaPhoneAlt, FaEye, FaRegHeart, FaShareAlt,
  FaEnvelope, FaIdCard, FaCheckCircle, FaUserCircle, FaLaptop,
  FaBriefcase, FaWhatsapp, FaTelegramPlane, FaMailBulk, FaBold,
  FaHome, FaCalendarAlt, FaExchangeAlt, FaMapMarkerAlt, FaFileAlt,
  FaPassport, FaMoneyBillAlt, FaInfoCircle, FaUtensils, FaStar,
  FaLanguage, FaCogs, FaUserFriends, FaGraduationCap, FaCamera,
  FaMotorcycle, FaCar, FaBan, FaVideo
} from 'react-icons/fa';
import { Button, Card, Image, Col, Row, Container } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { useNavigate, useLocation } from 'react-router-dom';
import PublicNavbar from '../../Pages/Navbar/Navbar';
import JobSeekerNavbar from '../../Pages/Navbar/JobSeekerNavbar';
import EmployerNavbar from '../../Pages/Navbar/EmployerNavbar';
import AgencyNavbar from '../../Pages/Navbar/AgencyNavbar';
import Swal from 'sweetalert2';
import { getVisibleOfferBadgeText, getVisibleSourceLabel, hasHighlightedSourceLabel, hasVisibleOfferBadge, formatApplyForCountry } from '../../../utils/candidateBadges';
import Register from './Register';
import '../../JobSeeker/CombinedProfileCard/CombinedProfileCard.css';
import '../../Employer/Candidates/CandidateView.css';
import '../../JobSeeker/ResumeUpdate/DoctorProfile/ProfileView/Drprofileview1.css';
import './CandidateDetails.css';
import './Candidates.css';
import { RiMessage2Fill } from "react-icons/ri";
import Doctorimg from '../../Pages/Images/WhatsApp Image 2025-06-12 at 5.33.20 PM.webp';
import Login from './Login';
import Footer from "../../Footer/Footer"
import moment from 'moment';

const ViewCandidates = () => {
  const [profileData, setProfileData] = useState(null);
  const [relatedCandidates, setRelatedCandidates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showReportForm, setShowReportForm] = useState(false);
  const [showRegisterPopup, setShowRegisterPopup] = useState(false);
  // const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [isDoctorProfile, setIsDoctorProfile] = useState(false);
  const [reportData, setReportData] = useState({
    email: '',
    reason: '',
    details: ''
  });
  const [isShortlisted, setIsShortlisted] = useState(false);
  const [shortlisting, setShortlisting] = useState(false);
  const [hasContactAccess, setHasContactAccess] = useState(false);
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [featureData, setFeatureData] = useState(null);

  const { userId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem('user')) || {};
  const isOwnProfile = !!user?.id && String(user.id) === String(userId);

  // Pick the correct navbar based on the logged-in user's role
  const NavbarComponent = (() => {
    if (!user.role) return PublicNavbar;
    const roleLower = user.role.toLowerCase();
    if (roleLower === 'job seeker' || roleLower === 'job_seeker') return JobSeekerNavbar;
    if (roleLower === 'employer') return EmployerNavbar;
    if (roleLower === 'agency' || roleLower === 'agency_admin') return AgencyNavbar;
    return PublicNavbar;
  })();

  console.log("Received userId:", userId);

  const [agencyContactDetails, setAgencyContactDetails] = useState(null);

  const formatContactWithCode = (countryCode, number) => {
    const rawCode = String(countryCode || '').trim();
    const trimmedNumber = String(number || '').trim();
    const trimmedCode = rawCode ? rawCode.split('(')[0].trim() : '';

    if (!trimmedCode && !trimmedNumber) return 'Not provided';
    if (!trimmedCode) return trimmedNumber;
    if (!trimmedNumber) return trimmedCode;

    return `${trimmedCode} ${trimmedNumber}`;
  };

  // Show second onboarding popup when returning from choosephoto page
  useEffect(() => {
    if (location.state?.showProfilePopupOnReturn) {
      // setTimeout(() => showProfileOnboardingPopup(), 600);
    }
  }, []);

  // Add this useEffect after the existing useEffects
  useEffect(() => {
    const fetchAgencyContactDetails = async () => {
      if (profileData?.source?.toLowerCase() === 'agency' && profileData.agency_uid) {
        try {
          const response = await fetch(`${BaseUrl}/api/agency`);
          if (!response.ok) {
            throw new Error('Failed to fetch agency data');
          }
          const agencies = await response.json();
          const candidateAgency = agencies.find(agency => agency.id === profileData.agency_uid);

          if (candidateAgency) {
            setAgencyContactDetails({
              agency_name: candidateAgency.agency_name,
              email: candidateAgency.email,
              phone: candidateAgency.official_phone
            });
          }
        } catch (err) {
          console.error("Error fetching agency details:", err);
        }
      }
    };

    if (profileData) {
      fetchAgencyContactDetails();
    }
  }, [profileData]);

  useEffect(() => {
    const checkAccess = async () => {
      if (isOwnProfile) {
        setIsUnlocked(true);
        return;
      }

      if (user.role?.toLowerCase() === 'employer' && user.id) {
        try {
          const response = await fetch(`${BaseUrl}/api/employer/check-feature?employer_id=${user.id}&feature=employer_contact_unlock`);
          const data = await response.json();
          setHasContactAccess(data.allowed);
          setFeatureData(data);

          // Check if SPECIFIC candidate is unlocked
          const unlockCheck = await fetch(`${BaseUrl}/api/employer/contact-unlock/check?employer_id=${user.id}&candidate_user_id=${userId}`);
          const unlockData = await unlockCheck.json();
          setIsUnlocked(unlockData.unlocked);
        } catch (error) {
          console.error("Error checking contact access:", error);
          // Fallback to old gold plan check if API fails
          setHasContactAccess(user.plan_name?.toLowerCase() === 'gold');
        }
      }
    };
    checkAccess();
  }, [isOwnProfile, user.id, user.role, userId]);

  const handleUnlockContact = async () => {
    if (!user.id) {
      Swal.fire({
        title: 'Registration Required',
        text: 'You need to register or login to view contact details',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Register',
        cancelButtonText: 'Login'
      }).then((result) => {
        if (result.isConfirmed) {
          navigate('/register', { state: { defaultTab: 'employer', source: 'candidateView', candidateId: userId } });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          navigate('/login');
        }
      });
      return false;
    }

    try {
      // 1. Check feature check first (limit check)
      const response = await fetch(`${BaseUrl}/api/employer/check-feature?employer_id=${user.id}&feature=employer_contact_unlock`);
      const data = await response.json();

      if (!data.allowed) {
        Swal.fire({
          icon: 'warning',
          title: 'Unlock Required',
          text: data.reason === 'limit_reached'
            ? 'Your contact unlock limit has been reached. Please upgrade your plan for more access.'
            : 'Accessing contact details requires a "Candidate Contact (Employer)" subscription feature.',
          showCancelButton: true,
          confirmButtonText: 'View Plans',
          cancelButtonText: 'Cancel'
        }).then((result) => {
          if (result.isConfirmed) navigate('/subscriptionplans');
        });
        return false;
      }

      // 2. Prompt for unlock
      const usageText = data.limit > 0 ? `(Usage: ${data.used}/${data.limit})` : '(Unlimited usage)';
      const result = await Swal.fire({
        title: 'Unlock Contact?',
        text: `Would you like to unlock contact details for this candidate? ${usageText}`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Unlock Now',
        cancelButtonText: 'Not Now'
      });

      if (result.isConfirmed) {
        const unlockResponse = await fetch(`${BaseUrl}/api/employer/contact-unlock`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ employer_id: user.id, candidate_user_id: userId })
        });
        const unlockData = await unlockResponse.json();

        if (unlockData.unlocked) {
          setIsUnlocked(true);
          Swal.fire({
            icon: 'success',
            title: 'Unlocked!',
            text: 'Contact details are now available.',
            timer: 1500,
            showConfirmButton: false
          });
          return true;
        } else {
          throw new Error(unlockData.error || 'Failed to unlock');
        }
      }
      return false;
    } catch (error) {
      console.error('Error in contact unlock:', error);
      Swal.fire({ icon: 'error', title: 'Error', text: 'Something went wrong while unlocking. Please try again.' });
      return false;
    }
  };

  const recordProfileView = async (targetId, targetType, viewType, itemId = null) => {
    try {
      if (!user.id || user.id === targetId) return;
      await fetch(`${BaseUrl}/api/profile-viewers/record`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          target_user_id: targetId,
          target_user_type: targetType,
          viewer_user_id: user.id,
          viewer_name: user.name || user.first_name || 'Anonymous',
          viewer_email: user.email || user.email_id || '',
          viewer_phone: user.mobile_number || user.phone || user.mobile || '',
          viewer_user_type: user.role,
          view_type: viewType,
          viewed_item_id: itemId
        })
      });
    } catch (err) {
      console.error('Error recording view:', err);
    }
  };

  const relatedCandidateRef = React.useRef(null);

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        console.log("Fetching data for userId:", userId);

        const response = await fetch(`${BaseUrl}/api/job-seeker/merged/${userId}`);
        console.log("Raw response:", response);

        if (!response.ok) {
          throw new Error('Failed to fetch profile data');
        }

        const data = await response.json();
        console.log("Fetched profile data:", data);

        if (data.profile_photo) {
          data.profile_photo = `${BaseUrl}${data.profile_photo}`;
          console.log("Updated profile photo URL:", data.profile_photo);
        }

        setProfileData(data);

        // Record the view
        if (data.agency_uid) {
          // Record view for the agency who posted the candidate
          recordProfileView(data.agency_uid, 'agency', 'candidate', userId);
        } else {
          // Fallback to recording view for the candidate themselves if no agency_uid
          recordProfileView(userId, 'job seeker', 'profile');
        }

        // Finalize access check for this profile
        if (isOwnProfile) {
          setIsUnlocked(true);
        } else if (user.role?.toLowerCase() === 'employer' && user.id) {
          const unlockCheck = await fetch(`${BaseUrl}/api/employer/contact-unlock/check?employer_id=${user.id}&candidate_user_id=${userId}`);
          const unlockData = await unlockCheck.json();
          setIsUnlocked(unlockData.unlocked);
        }

        const jobPositions = Array.isArray(data.job_position)
          ? data.job_position
          : JSON.parse(data.job_position || "[]");

        // Doctor profiles should stay in the shared nurse/common candidate flow.
        setIsDoctorProfile(false);

        // Fetch related candidates based on job_position
        if (data.job_position && data.job_position.length > 0) {
          const candidatesResponse = await fetch(`${BaseUrl}/api/job-seeker`);
          if (!candidatesResponse.ok) {
            throw new Error('Failed to fetch related candidates');
          }
          let candidatesData = await candidatesResponse.json();

          // Filter candidates based on verification status and plan_enddate
          const currentDate = new Date().toISOString().split('T')[0];
          candidatesData = candidatesData.filter(candidate => {
            if (candidate.verification_status?.toLowerCase() !== 'verified') {
              return false;
            }
            if (candidate.source?.toLowerCase() === 'agency') {
              return candidate.plan_enddate && new Date(candidate.plan_enddate) >= new Date(currentDate);
            }
            return true;
          });

          // Parse array fields for related candidates
          candidatesData = candidatesData.map(candidate => ({
            ...candidate,
            job_position: safeParseArray(candidate.job_position),
            language: safeParseArray(candidate.language),
            main_skills: safeParseArray(candidate.main_skills),
            preferred_countries: safeParseArray(candidate.preferred_countries),
            work_experience: safeParseArray(candidate.work_experience),
            profile_photo: candidate.profile_photo ? `${BaseUrl}${candidate.profile_photo}` : candidate.profile_photo
          }));

          // Filter related candidates by matching job_position, excluding the current candidate
          const related = candidatesData.filter(candidate =>
            candidate.user_id !== parseInt(userId) &&
            candidate.job_position.some(pos =>
              jobPositions.some(p => p.toLowerCase() === pos.toLowerCase())
            )
          );
          setRelatedCandidates(related);
        }
      } catch (err) {
        console.error("Error fetching profile data:", err.message);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (userId) {
      fetchProfileData();
    }
  }, [userId]);

  // Check if candidate is already shortlisted
  useEffect(() => {
    const checkShortlistStatus = async () => {
      if (!user.id || !["agency", "agency_admin"].includes(user.role?.toLowerCase())) return;

      try {
        const response = await fetch(`${BaseUrl}/shortlist/employer/${user.id}`);
        if (response.ok) {
          const data = await response.json();
          const isAlreadyShortlisted = data.some(item => String(item.user_id) === String(userId));
          setIsShortlisted(isAlreadyShortlisted);
        }
      } catch (err) {
        console.error("Error checking shortlist status:", err);
      }
    };

    if (userId && user.id && user.role) {
      checkShortlistStatus();
    }
  }, [userId, user.id, user.role]);

  const handleShortlist = async () => {
    if (!user.id) {
      Swal.fire({
        title: 'Login Required',
        text: 'Please login as an agency to shortlist candidates',
        icon: 'info',
        confirmButtonText: 'Login'
      }).then(() => navigate('/login'));
      return;
    }

    if (!["agency", "agency_admin"].includes(user.role?.toLowerCase())) {
      Swal.fire({
        title: 'Access Denied',
        text: 'Only agencies can shortlist candidates',
        icon: 'warning'
      });
      return;
    }

    if (isShortlisted) {
      Swal.fire({
        icon: 'info',
        title: 'Already Shortlisted',
        text: 'This candidate is already in your shortlist.'
      });
      return;
    }

    setShortlisting(true);
    try {
      const response = await fetch(`${BaseUrl}/shortlist`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_id: userId,
          employer_id: user.id,
          first_name: profileData.first_name,
          email_id: profileData.email_id,
          mobile_number: profileData.phone_number || profileData.whatsapp_number,
          employer_source: 'agency'
        }),
      });

      if (response.ok) {
        setIsShortlisted(true);
        Swal.fire({
          icon: 'success',
          title: 'Shortlisted!',
          text: 'Candidate has been added to your shortlist.',
          timer: 2000,
          showConfirmButton: false
        });
      } else {
        const data = await response.json();
        throw new Error(data.message || 'Failed to shortlist candidate');
      }
    } catch (err) {
      console.error('Error shortlisting candidate:', err);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: err.message || 'An error occurred while shortlisting'
      });
    } finally {
      setShortlisting(false);
    }
  };

  // Onboarding popup for first-time visit by own profile
  useEffect(() => {
    if (!userId || !user.id) return;
    // Only show for the profile owner
    if (String(user.id) !== String(userId)) return;
    // Only show once — check localStorage flag
    const onboardingKey = `gw_onboarding_done_${userId}`;
    if (localStorage.getItem(onboardingKey)) return;
    // Wait for profile data to load before triggering
    if (loading) return;
    // Show the first popup (photo upload)
    const timer = setTimeout(() => {
      showPhotoOnboardingPopup();
    }, 800);
    return () => clearTimeout(timer);
  }, [userId, user.id, loading]);

  // Helper function to safely parse array fields
  const safeParseArray = (field) => {
    if (Array.isArray(field)) return field;
    if (typeof field === 'string') {
      try {
        const parsed = JSON.parse(field.replace(/\\"/g, '"'));
        return Array.isArray(parsed) ? parsed : [];
      } catch {
        return [];
      }
    }
    return [];
  };

  const handleContactClick = () => {
    if (!user.id) {
      Swal.fire({
        title: 'Registration Required',
        text: 'You need to register or login to contact this candidate',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Register',
        cancelButtonText: 'Login',
        customClass: {
          popup: 'registration-popup'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          // Navigate to /register page with state to select Employer tab
          navigate('/register', {
            state: {
              defaultTab: 'employer', // This will auto-select Employer tab
              source: 'candidateView', // Optional: to track where it came from
              candidateId: userId // Optional: include candidate ID for reference
            }
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          navigate('/login');
        }
      });
    } else {
      // Handle contact logic for logged in users
      Swal.fire({
        title: 'Contact Candidate',
        text: 'This feature will allow you to contact the candidate directly',
        icon: 'info',
        confirmButtonText: 'OK'
      });
    }
  };

  const closeRegisterPopup = () => {
    setShowRegisterPopup(false);
  };

  // const closeLoginPopup = () => {
  //   setShowLoginPopup(false);
  // };

  const handleLoginSuccess = () => {
    // closeLoginPopup();
    // You can add additional logic here after successful login
  };

  const safeParseJSON = (jsonString) => {
    if (!jsonString) return [];
    try {
      if (typeof jsonString === 'object') return jsonString;
      const cleanedString = jsonString.replace(/\\"/g, '"');
      return JSON.parse(cleanedString);
    } catch (e) {
      if (Array.isArray(jsonString)) return jsonString;
      if (typeof jsonString === 'string') return [jsonString];
      return [];
    }
  };

  // Handle view click for related candidates
  const handleViewClick = (userId, first_name) => {
    navigate(`/allcandidatesdetails/${userId}`);
  };

  // Handle message click for related candidates
  const handleMessageClick = (candidate) => {
    Swal.fire({
      title: 'Message Candidate',
      text: `This would open a message modal for ${candidate.first_name}`,
      icon: 'info',
      confirmButtonText: 'OK'
    });
  };

  const jobPosition = safeParseJSON(profileData?.job_position);
  const languages = safeParseJSON(profileData?.language);
  const nursingLicenseCountries = safeParseJSON(profileData?.nursing_license_countries);
  const isWelderRole = jobPosition.some(pos => pos.toLowerCase().includes("welder"));
  const isElectricianRole = jobPosition.some(pos => pos.toLowerCase().includes("electrician"));
  const mainSkills = safeParseJSON(profileData?.main_skills);
  const cookingSkills = safeParseJSON(profileData?.cooking_skills);
  const otherSkills = safeParseJSON(profileData?.other_skills);
  const personality = safeParseJSON(profileData?.personality);
  const experience = safeParseJSON(profileData?.experience);
  const preferredLocations = safeParseJSON(profileData?.preffered_job_locations);
  const education = safeParseJSON(profileData?.education);
  const drivingLicenseCountries = safeParseJSON(profileData?.driving_license_country);
  const carTypes = safeParseJSON(profileData?.car_type);
  const previousCars = safeParseJSON(profileData?.previous_car);
  const bikeTypes = safeParseJSON(profileData?.bike_type);
  const previousBikes = safeParseJSON(profileData?.previous_bike);
  const deliveryExpTypes = safeParseJSON(profileData?.delivery_experience_types);
  const otherDeliveryApps = safeParseJSON(profileData?.other_delivery_apps);
  const deliveryCompanyNames = safeParseJSON(profileData?.delivery_company_names);
  const welderWeldingProcess = safeParseJSON(profileData?.welding_process);
  const welderWeldingPositions = safeParseJSON(profileData?.welding_positions);
  const welderMaterialExperience = safeParseJSON(profileData?.material_experience);
  const welderThicknessWorkedOn = safeParseJSON(profileData?.thickness_worked_on);
  const welderTechnicalKnowledge = safeParseJSON(profileData?.welder_technical_knowledge);
  const isFabricatorPipeFitterRole = jobPosition.some(pos => pos.toLowerCase().includes("fabricator") || pos.toLowerCase().includes("pipe fitter"));
  const fabricatorTechnicalSkills = safeParseJSON(profileData?.fabricator_technical_skills);
  const fabricatorToolsKnowledge = safeParseJSON(profileData?.fabricator_tools_knowledge);
  const softwareItProgrammingLanguages = safeParseJSON(profileData?.software_it_programming_languages);
  const softwareItFrameworks = safeParseJSON(profileData?.software_it_frameworks);
  const softwareItDatabaseSkills = safeParseJSON(profileData?.software_it_database_skills);
  const softwareItOtherSkills = safeParseJSON(profileData?.software_it_other_skills);
  const softwareItCertifications = safeParseJSON(profileData?.software_it_certifications);
  const softwareItOtherProgrammingLanguage = String(profileData?.software_it_other_programming_language || '').trim();
  const softwareItOtherCertification = String(profileData?.software_it_other_certification || '').trim();

  const isACTechnicianRole = jobPosition.some(pos => pos.toLowerCase().includes("ac technician") || pos.toLowerCase().includes("hvac technician"));
  const acSystems = safeParseJSON(profileData?.ac_systems);
  const hvacSystems = safeParseJSON(profileData?.hvac_systems);
  const acTechnicalSkills = safeParseJSON(profileData?.ac_technical_skills);
  const acToolsKnowledge = safeParseJSON(profileData?.ac_tools_knowledge);

  const isChillerTechnicianRole = jobPosition.some(pos => pos.toLowerCase().includes("chiller technician"));
  const chillerType = safeParseJSON(profileData?.chiller_type);
  const chillerSystemKnowledge = safeParseJSON(profileData?.chiller_system_knowledge);
  const chillerTechnicalSkills = safeParseJSON(profileData?.chiller_technical_skills);
  const chillerRefrigerantKnowledge = safeParseJSON(profileData?.chiller_refrigerant_knowledge);
  const chillerToolsKnowledge = safeParseJSON(profileData?.chiller_tools_knowledge);

  const electricianElectricalExp = safeParseJSON(profileData?.electrical_experience);

  const hasWelderDetails = Boolean(profileData?.industry) || welderWeldingProcess.length > 0 || welderWeldingPositions.length > 0 || welderMaterialExperience.length > 0 || welderThicknessWorkedOn.length > 0 || welderTechnicalKnowledge.length > 0 || Boolean(profileData?.iti_trade_certificate) || Boolean(profileData?.welding_certificate) || Boolean(profileData?.welding_certificate_type) || Boolean(profileData?.passed_trade_test);
  const hasFabricatorDetails = Boolean(profileData?.industry) || fabricatorTechnicalSkills.length > 0 || fabricatorToolsKnowledge.length > 0 || Boolean(profileData?.iti_trade_certificate) || Boolean(profileData?.passed_trade_test);
  const hasACTechnicianDetails = acSystems.length > 0 || hvacSystems.length > 0 || acTechnicalSkills.length > 0 || acToolsKnowledge.length > 0;
  const hasChillerDetails = chillerType.length > 0 || chillerSystemKnowledge.length > 0 || chillerTechnicalSkills.length > 0 || chillerRefrigerantKnowledge.length > 0 || chillerToolsKnowledge.length > 0;

  const latheMachineKnowledge = safeParseJSON(profileData?.lathe_machine_knowledge);
  const millingMachineKnowledge = safeParseJSON(profileData?.milling_machine_knowledge);  const latheTechnicalSkills = safeParseJSON(profileData?.lathe_technical_skills);
  const latheMaterialExperience = safeParseJSON(profileData?.lathe_material_experience);
  const isLatheMachineRole = Array.isArray(profileData?.job_position)
    ? profileData.job_position.some(p => ["Lathe & Milling Machine", "Lathe Machine Operator", "Milling Machine Operator"].includes(p))
    : ["Lathe & Milling Machine", "Lathe Machine Operator", "Milling Machine Operator"].includes(profileData?.job_position);
  const hasLatheDetails = latheMachineKnowledge.length > 0 || millingMachineKnowledge.length > 0 || latheTechnicalSkills.length > 0 || latheMaterialExperience.length > 0;
  const electricianAutomation = safeParseJSON(profileData?.automation_controls);
  const electricianDrawing = safeParseJSON(profileData?.drawing_testing);
  const electricianVoltageExp = safeParseJSON(profileData?.voltage_experience);

  const isNurseRole = jobPosition.some(pos => pos.toLowerCase().includes("nurse"));
  const isHospitalOrHealthcareCategory = ["hospital", "healthcare"].includes(
    String(profileData?.category || "").toLowerCase()
  );
  const nursingLicenseDisplay = [...nursingLicenseCountries, profileData?.other_nursing_license_country]
    .filter(lib => lib && lib !== "I Don't have License" && lib !== "Not Licensed")
    .join(', ') || "Not Licensed";

  const hasElectricianDetails = Boolean(profileData?.electrician_industry_type) || electricianElectricalExp.length > 0 || electricianAutomation.length > 0 || electricianDrawing.length > 0 || electricianVoltageExp.length > 0 || Boolean(profileData?.max_voltage) || Boolean(profileData?.iti_diploma_electrical) || Boolean(profileData?.electrical_license) || Boolean(profileData?.electrical_trade_test_passed) || Boolean(profileData?.electrical_ready_for_test);
  const hasSoftwareItDetails =
    softwareItProgrammingLanguages.length > 0 ||
    softwareItFrameworks.length > 0 ||
    softwareItDatabaseSkills.length > 0 ||
    softwareItOtherSkills.length > 0 ||
    softwareItCertifications.length > 0 ||
    Boolean(softwareItOtherProgrammingLanguage) ||
    Boolean(softwareItOtherCertification);

  const formatSoftwareItDisplay = (items = [], otherValue = '') => {
    const normalizedItems = Array.isArray(items) ? items.filter(Boolean) : [];
    const filteredItems = normalizedItems.filter(item => item !== 'Other');

    if (otherValue) {
      return [...filteredItems, `Other: ${otherValue}`];
    }

    return filteredItems;
  };

  const isElevatorTechnicianRole = jobPosition.some(pos => [
    "Elevator Technician",
    "Elevator Installation Technician",
    "Elevator Maintenance Technician",
    "Elevator Repair Technician",
    "Escalator Technician"
  ].includes(pos));
  const elevatorFieldExperience = safeParseJSON(profileData?.elevator_field_experience);
  const elevatorSystemKnowledge = safeParseJSON(profileData?.elevator_system_knowledge);
  const elevatorControlExperience = safeParseJSON(profileData?.elevator_control_experience);
  const elevatorBrandExperience = safeParseJSON(profileData?.elevator_brand_experience);
  const hasElevatorDetails = elevatorFieldExperience.length > 0 || elevatorSystemKnowledge.length > 0 || elevatorControlExperience.length > 0 || elevatorBrandExperience.length > 0 || Boolean(profileData?.elevator_technical_diploma) || Boolean(profileData?.elevator_safety_training);

  const toggleReportForm = () => {
    if (!user.id) {
      Swal.fire({
        title: 'Registration Required',
        text: 'You need to register or login to report this candidate',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Register',
        cancelButtonText: 'Login',
        customClass: {
          popup: 'registration-popup'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          setShowRegisterPopup(true);
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          navigate('/login');
        }
      });
      return;
    }
    setShowReportForm(!showReportForm);
  };

  const handleReportChange = (e) => {
    const { name, value } = e.target;
    setReportData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleReportSubmit = async (e) => {
    e.preventDefault();

    if (!user.id) {
      Swal.fire({
        title: 'Login Required',
        text: 'You need to login to report this candidate',
        icon: 'info',
        confirmButtonText: 'Login'
      }).then(() => {
        navigate('/login');
      });
      return;
    }

    try {
      const response = await fetch(`${BaseUrl}/api/reports`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...reportData,
          candidate_id: profileData.id,
          user_id: user.id
        }),
      });

      if (response.ok) {
        Swal.fire({
          icon: 'success',
          title: 'Report Submitted',
          text: 'Thank you for reporting this candidate. Our team will review it shortly.',
          confirmButtonColor: '#28a745'
        });
        setShowReportForm(false);
        setReportData({
          email: '',
          reason: '',
          details: ''
        });
        navigate('/candidates');
      } else {
        const data = await response.json();
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: data.error || 'Failed to submit report',
          confirmButtonColor: '#d33'
        });
      }
    } catch (err) {
      console.error('Error submitting report:', err);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'An error occurred while submitting your report',
        confirmButtonColor: '#d33'
      });
    }
  };

  // Add this helper function at the top of your component, after the imports
  const formatSalary = (salary) => {
    const salaryNum = typeof salary === 'string' ? parseFloat(salary) : salary;

    if (isNaN(salaryNum) || salaryNum === null || salaryNum === undefined || salaryNum === 0) return 'Negotiable';

    // Round to nearest integer
    const roundedSalary = Math.round(salaryNum);

    return roundedSalary.toString();
  };

  const getDisplayCategory = (profile) => {
    const rawPositions = typeof profile?.job_position === 'string' && profile.job_position.startsWith('[')
      ? JSON.parse(profile.job_position)
      : profile?.job_position;
    const positionText = Array.isArray(rawPositions)
      ? rawPositions.join(' ').toLowerCase()
      : String(rawPositions || '').toLowerCase();

    if (
      positionText.includes('midwife') ||
      positionText.includes('physiotherapy') ||
      positionText.includes('physiotherapist')
    ) return 'Hospital';

    return profile?.category || 'Not specified';
  };

  const salaryDisplayConversionRates = {
    QAR: 0.27,
    SAR: 0.27,
    AED: 0.27,
    BHD: 2.65,
    OMR: 2.60,
    KWD: 3.25,
    EUR: 1.07,
    GBP: 1.24,
    CHF: 1.13,
    NOK: 0.095,
    SEK: 0.098,
    DKK: 0.14,
    PLN: 0.25,
    CZK: 0.043,
    HUF: 0.0027,
    RON: 0.21,
    BGN: 0.55,
    RSD: 0.0092,
    TRY: 0.030,
    USD: 1,
    INR: 0.012,
    SGD: 0.74,
    MYR: 0.21,
    HKD: 0.13,
    JPY: 0.0068,
    KRW: 0.00076,
    ILS: 0.27,
    MUR: 0.022,
    SCR: 0.073,
    BND: 0.74
  };

  const getSalaryExpectationDisplay = (profile) => {
    const rawCurrency = profile?.expected_monthly_salary_currency || '';
    const parts = rawCurrency.split(' | ').map(part => part.trim()).filter(Boolean);
    const currencyLabel = parts[0] || '';
    const salaryType = parts[1] || '';
    const salaryDisplay = parts[2] || '';
    const currencyCodeMatch = currencyLabel.match(/^([A-Z]{3})/);
    const currencyCode = currencyCodeMatch ? currencyCodeMatch[1] : 'Local';
    const usdValue = parseFloat(profile?.expected_monthly_salary_usd) || 0;
    const localValue = parseFloat(profile?.expected_monthly_salary) || 0;

    if (salaryType === 'Negotiable' || (!salaryDisplay && usdValue === 0 && localValue === 0)) {
      return {
        localLabel: currencyCode,
        localValue: 'Negotiable',
        usdValue: 'Negotiable'
      };
    }

    if (salaryType === 'Salary Range' && salaryDisplay) {
      const normalized = salaryDisplay.replace(/,/g, '');
      const rate = salaryDisplayConversionRates[currencyCode];

      if (normalized.includes('–')) {
        const [minValue, maxValue] = normalized.split('–').map(part => parseFloat(part) || 0);
        const usdRange = rate
          ? `$${Math.round(minValue * rate)}-$${Math.round(maxValue * rate)}`
          : usdValue > 0 ? `$${Math.round(usdValue)}` : 'Negotiable';

        return {
          localLabel: currencyCode,
          localValue: salaryDisplay,
          usdValue: usdRange
        };
      }

      if (normalized.includes('+')) {
        const minValue = parseFloat(normalized.replace('+', '')) || 0;
        const usdRange = rate
          ? `$${Math.round(minValue * rate)}+`
          : usdValue > 0 ? `$${Math.round(usdValue)}+` : 'Negotiable';

        return {
          localLabel: currencyCode,
          localValue: salaryDisplay,
          usdValue: usdRange
        };
      }
    }

    if (salaryDisplay) {
      return {
        localLabel: currencyCode,
        localValue: salaryDisplay,
        usdValue: usdValue > 0 ? `$${Math.round(usdValue)}` : 'Negotiable'
      };
    }

    return {
      localLabel: currencyCode,
      localValue: localValue > 0 ? Math.round(localValue).toString() : 'Negotiable',
      usdValue: usdValue > 0 ? `$${Math.round(usdValue)}` : 'Negotiable'
    };
  };

  const handleDashboard = () => {
    if (!user) {
      navigate('/');
      return;
    }
    if (user.role === 'employer') {
      navigate('/employer-dashboard');
    } else if (user.role === 'agency_admin' || user.role === 'agency') {
      navigate('/agencydashboard');
    } else {
      navigate('/jobseeker-dashboard');
    }
  };

  // Onboarding handlers — SweetAlert2 with native styling to match site
  const showPhotoOnboardingPopup = () => {
    // ✅ Mark onboarding as triggered immediately — prevents re-show on page revisit
    const onboardingKey = `gw_onboarding_done_${userId}`;
    localStorage.setItem(onboardingKey, '1');

    Swal.fire({
      title: 'Add Your Profile Photo',
      html: `<p style="color:#555;font-size:14px;line-height:1.6;">
        Profiles with photos get <strong style="color:#28a745;">3x more responses</strong> from employers.
        Add a clear face photo to stand out!
      </p>`,
      iconHtml: `<span style="font-size:38px;">📸</span>`,
      showCancelButton: false,
      showCloseButton: true,
      confirmButtonText: 'Upload Photo',
      confirmButtonColor: '#28a745',
      customClass: {
        icon: 'border-0'
      }
    }).then((result) => {
      if (result.isConfirmed) {
        navigate('/choosephoto', { state: { userId, fromProfile: true, showProfilePopupAfter: true } });
      } else {
        // Skip → show profile completion popup
        // showProfileOnboardingPopup();
      }
    });
  };

  // Complete Your Profile popup disabled as requested
  // const showProfileOnboardingPopup = () => {
  //   ...popup code commented out...
  // };

  if (loading) {
    return (
      <>
        <NavbarComponent />
        <div className="text-center mt-5" style={{ marginTop: '50px' }}>Loading profile data...</div>
      </>
    );
  }

  if (error) {
    return (
      <>
        <NavbarComponent />
        <div className="text-center mt-5 text-danger">Error: {error}</div>
      </>
    );
  }

  if (!profileData) {
    return (
      <>
        <NavbarComponent />
        <Container className="text-center" style={{ marginTop: '150px', marginBottom: '100px' }}>
          <Card className="p-5 shadow-sm border-0 rounded-4">
            <div className="mb-4">
              <FaInfoCircle size={60} className="text-muted mb-3" />
              <h2 className="fw-bold text-dark">Profile Not Found</h2>
              <p className="text-secondary fs-5">
                We couldn't find the profile details for this candidate.
              </p>
            </div>

            {user && String(user.id) === String(userId) ? (
              <div className="mt-4">
                <p className="mb-4">It looks like your profile is not yet completed. Complete your profile to start appearing in searches!</p>
                <Button
                  variant="success"
                  size="lg"
                  onClick={() => navigate('/personalinfo')}
                  className="px-5 py-3 rounded-pill fw-bold shadow-sm"
                >
                  <FaUser className="me-2" /> Complete My Profile
                </Button>
              </div>
            ) : (
              <Button
                variant="outline-secondary"
                onClick={() => navigate(-1)}
                className="mt-3 px-4 rounded-pill"
              >
                ← Back to Candidates
              </Button>
            )}
          </Card>
        </Container>
      </>
    );
  }

  return (
    <>
      <NavbarComponent />
      {isDoctorProfile ? (
        <div className="dr-profile-container">
          {/* Doctor Profile UI */}
          <Container className="p-0 candidate-view-container" style={{ marginTop: '100px' }}>
            <Row className="mx-0">

              <Col md={8} className="px-3 mb-4">
                {/* ADD THIS CARD WRAPPER */}
                <div className="combined-profile-details-card bg-white shadow rounded-4">

                  <div className="dr-profile-background">
                    <div className="d-flex justify-content-between dr-profile-newbutton">
                      {["agency", "agency_admin"].includes(user.role?.toLowerCase()) && (
                        <Button
                          variant={isShortlisted ? "secondary" : "warning"}
                          size="sm"
                          className="ms-2 px-3 fw-bold shadow-sm"
                          onClick={handleShortlist}
                          disabled={shortlisting || isShortlisted}
                        >
                          <FaRegHeart className="me-1" /> {isShortlisted ? "Shortlisted" : "Shortlist"}
                        </Button>
                      )}
                    </div>

                    {user && String(user.id) === String(userId) && (
                      <div className="d-flex justify-content-center align-items-center flex-wrap px-3 pt-3">
                        <Button variant="outline-primary" onClick={handleDashboard} className="me-3 mb-2 px-4 shadow-sm">
                          <FaHome className="me-2" /> Dashboard
                        </Button>
                        <Button variant="primary" onClick={() => navigate('/personalinfo')} className="me-3 mb-2 px-4 shadow-sm">
                          <FaUser className="me-2" /> Complete Profile
                        </Button>
                        <Button variant="info" onClick={() => navigate('/choosephoto', { state: { userId, fromProfile: true } })} className="me-3 mb-2 px-4 shadow-sm text-white">
                          <FaCamera className="me-2" /> Upload Photo
                        </Button>
                        <Button variant="outline-success" onClick={() => navigate('/viewjobs')} className="mb-2 px-4 shadow-sm">
                          <FaBriefcase className="me-2" /> View Job Postings
                        </Button>
                      </div>
                    )}

                    <div className="d-flex justify-content-center position-relative mt-3">
                      <div className="profile-img-wrapper position-relative mx-auto mb-3">
                        {profileData.profile_photo ? (
                          <img
                            src={profileData.profile_photo}
                            alt="Profile"
                            className="profile-img rounded-circle"
                            style={{ width: '150px', height: '150px', objectFit: 'cover', objectPosition: 'center center' }}
                          />
                        ) : (
                          <div
                            className="profile-img rounded-circle d-flex align-items-center justify-content-center bg-light overflow-hidden"
                            style={{ width: '150px', height: '150px' }}
                          >
                            <FaUserCircle size={150} color="#b8c0d6" style={{ display: 'block' }} />
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="mt-3 text-center">
                      <p className="fw-bold text-primary mb-1">
                        Name - Dr. {profileData.first_name} | Age - {profileData.age} Years
                      </p>
                      <p className="text-dark small fw-semibold">
                        Posted {new Date(profileData.created_at).toLocaleDateString()}
                      </p>
                    </div>
                  </div>

                  {/* Divider */}
                  <hr className="profile-divider" />

                  {/* Personal Information Section */}
                  <div className="dr-profile-card p-3">
                    <div className="dr-profile-header">
                      <FaIdCard size={32} className="dr-profile-icon" />
                      <span className="dr-profile-title">Personal Information</span>
                    </div>

                    <div className="dr-profile-card-body">
                      {/* Doctor Info */}
                      <h5 className="dr-profile-sub-title">
                        <FaCheckCircle className="dr-profile-check-icon" /> Doctor Information
                      </h5>

                      <div className="dr-profile-info">
                        <div className="info-row">
                          <span className="dot"></span> Position - {profileData.dtr_medical_job_position || "Doctor"}
                        </div>
                        <div className="info-row">
                          <span className="dot"></span> Qualification - {profileData.dtr_ug_qualification} | {profileData.dtr_pg_qualification}
                        </div>
                        <div className="info-row">
                          <span className="dot"></span> Language - {profileData.dtr_english_lang_qualifications}, {profileData.dtr_other_language_qualifications}
                        </div>
                        <div className="info-row">
                          <span className="dot"></span> Country License - {profileData.dtr_country_doctor_license?.map(license => license.country_name).join(", ")}
                        </div>
                        <div className="info-row">
                          <span className="dot"></span> Religion - {profileData.religion}
                        </div>
                        <div className="info-row">
                          <span className="dot"></span> Nationality - {profileData.nationality}
                        </div>
                        <div className="info-row">
                          <span className="dot"></span> Current Location - {profileData.current_country}
                        </div>
                        <div className="info-row">
                          <span className="dot"></span> Apply for - {formatApplyForCountry(profileData.country_apply_for_job)}
                        </div>
                        <div className="info-row">
                          <span className="dot"></span> Gender - {profileData.gender}
                        </div>
                        <div className="info-row">
                          <span className="dot"></span> Marital status - {profileData.marital_status}
                        </div>
                        <div className="info-row">
                          <span className="dot"></span> Post Internship Clinical exp. - {profileData.dtr_internship_clinical_experience} Yrs
                        </div>
                        <div className="info-row">
                          <span className="dot"></span> Post Graduation Clinical exp. - {profileData.dtr_graduation_clinical_experience} Yrs
                        </div>
                        <div className="info-row">
                          <span className="dot"></span> Total year of exp. as a Doctor - {profileData.dtr_years_of_experience_doctor} Yrs
                        </div>
                      </div>

                      {/* Hospital and Qualifications Sections */}
                      <h5 className="dr-profile-sub-title mt-4">
                        <FaCheckCircle className="dr-profile-check-icon" /> Current
                        Hospital Name, Starting & Ending Date
                      </h5>
                      <div className="dr-hospital-row">
                        <div className="dr-profile-box">{profileData.dtr_currently_working_hospital_name}</div>
                        <div className="dr-profile-box">{profileData.dtr_hospital_country}</div>
                      </div>
                      <div className="dr-hospital-row">
                        <div className="dr-profile-box">{new Date(profileData.dtr_work_start_date).toLocaleDateString()}</div>
                        <div className="dr-profile-box">
                          {profileData.dtr_work_end_date === "...On going"
                            ? "...On going"
                            : profileData.dtr_work_end_date
                              ? new Date(profileData.dtr_work_end_date).toLocaleDateString()
                              : "Running"
                          }
                        </div>
                      </div>

                      <h5 className="dr-profile-sub-title mt-4">
                        <FaCheckCircle className="dr-profile-check-icon" /> Previous
                        Hospital Name , Starting & Ending Date
                      </h5>
                      {profileData.dtr_previous_hospital_details?.map((hospital, index) => (
                        <div key={index}>
                          <div className="dr-hospital-row">
                            <div className="dr-profile-box">{hospital.previous_hospital_name}</div>
                            <div className="dr-profile-box">{hospital.hospital_country_name}</div>
                          </div>
                          <div className="dr-hospital-row">
                            <div className="dr-profile-box">{new Date(hospital.work_start_date).toLocaleDateString()}</div>
                            <div className="dr-profile-box">{new Date(hospital.work_end_date).toLocaleDateString()}</div>
                          </div>
                        </div>
                      ))}

                      <h5 className="dr-profile-sub-title mt-4">
                        <FaCheckCircle className="dr-profile-check-icon" /> Fellowship
                        Qualifications
                      </h5>
                      <div className="dr-hospital-row">
                        <div className="dr-profile-box">{profileData.dtr_fellowship_qualifications}</div>
                      </div>

                      <h5 className="dr-profile-sub-title mt-4">
                        <FaCheckCircle className="dr-profile-check-icon" /> Other
                        Language Qualifications
                      </h5>
                      <div className="dr-hospital-row">
                        <div className="dr-profile-box">{profileData.dtr_other_language_qualifications}</div>
                      </div>

                      <h5 className="dr-profile-sub-title mt-4">
                        <FaCheckCircle className="dr-profile-check-icon" /> Language
                        Proficiency Levels
                      </h5>
                      <div className="dr-hospital-row">
                        <div className="dr-profile-box">{profileData.dtr_language_proficiency}</div>
                      </div>

                      <h5 className="dr-profile-sub-title mt-4">
                        <FaCheckCircle className="dr-profile-check-icon" />Cultural Adaptation Qualifications
                      </h5>
                      <div className="dr-hospital-row">
                        <div className="dr-profile-box">{profileData.dtr_cultural_qualifications}</div>
                      </div>

                      <h5 className="dr-profile-sub-title mt-4">
                        <FaCheckCircle className="dr-profile-check-icon" /> Prometric Certificate
                      </h5>
                      <div className="dr-hospital-row">
                        <div className="dr-profile-box">{profileData.dtr_prometric_certificate ? "Yes" : "No"}</div>
                      </div>

                      <h5 className="dr-profile-sub-title mt-4">
                        <FaCheckCircle className="dr-profile-check-icon" />Prometric Certificate Issuing Country
                      </h5>
                      <div className="dr-hospital-row">
                        <div className="dr-profile-box">{profileData.dtr_prometric_issued_country}</div>
                      </div>

                      <h5 className="dr-profile-sub-title mt-4">
                        <FaCheckCircle className="dr-profile-check-icon" />Data flow certificate
                      </h5>
                      <div className="dr-hospital-row">
                        <div className="dr-profile-box">{profileData.dtr_data_flow_certificate ? "Yes" : "No"}</div>
                      </div>

                      <h5 className="dr-profile-sub-title mt-4">
                        <FaCheckCircle className="dr-profile-check-icon" /> Data flow certificate Issuing Country
                      </h5>
                      <div className="dr-hospital-row">
                        <div className="dr-profile-box">{profileData.dtr_data_flow_issued_by_country}</div>
                      </div>

                      <h5 className="dr-profile-sub-title mt-4">
                        <FaCheckCircle className="dr-profile-check-icon" /> My Preferred country for a job
                      </h5>
                      <div className="dr-hospital-row">
                        {profileData.dtr_preferred_country?.map((country, index) => (
                          <div key={index} className="dr-profile-box">{country}</div>
                        ))}
                      </div>

                      <h5 className="dr-profile-sub-title mt-4">
                        <FaCheckCircle className="dr-profile-check-icon" /> Language Skilled
                      </h5>
                      <div className="dr-hospital-row">
                        {profileData.dtr_language_skilled?.map((language, index) => (
                          <div key={index} className="dr-profile-box">{language}</div>
                        ))}
                      </div>

                      <h5 className="dr-profile-sub-title mt-4">
                        <FaCheckCircle className="dr-profile-check-icon" /> I have Doctor License From
                      </h5>
                      <div className="dr-hospital-row">
                        {profileData.dtr_country_doctor_license?.map((license, index) => (
                          <div key={index} className="dr-profile-box-license">{license.country_name}</div>
                        ))}
                      </div>

                      <h5 className="dr-profile-sub-title mt-4">
                        <FaCheckCircle className="dr-profile-check-icon" />I have Driving License From
                      </h5>
                      <div className="dr-hospital-row">
                        {profileData.dtr_driving_license_country?.map((country, index) => (
                          <div key={index} className="dr-profile-box">{country}</div>
                        ))}
                      </div>

                      <div className="dr-profile-header-professional">
                        {/* <FaUserCircle className="dr-profile-icon" /> */}
                        <span className="dr-profile-sub-title">Professional Information</span>
                      </div>

                      <div className="dr-profile-body">
                        <h5 className="dr-profile-sub-title mt-4">
                          <FaCheckCircle className="dr-profile-check-icon" />My Medical Specialties Job Position
                        </h5>
                        <div className="dr-hospital-row">
                          <div className="dr-profile-box">{profileData.dtr_medical_job_position}</div>
                        </div>

                        {/* Surgical Specialty */}
                        <h5 className="dr-profile-sub-title mt-4">
                          <FaCheckCircle className="dr-profile-check-icon" />My Surgical Specialties Job Position
                        </h5>
                        <div className="dr-hospital-row">
                          <div className="dr-profile-box">{profileData.dtr_surgical_job_position}</div>
                        </div>

                        <h5 className="dr-profile-sub-title mt-4">
                          <FaCheckCircle className="dr-profile-check-icon" />Other Medical Specialties Job Position
                        </h5>
                        <div className="dr-hospital-row">
                          <div className="dr-profile-box">{profileData.dtr_other_medical_job_position}</div>
                        </div>

                        <h5 className="dr-profile-sub-title mt-4">
                          <FaCheckCircle className="dr-profile-check-icon" />My Academic and Research Job Position
                        </h5>
                        <div className="dr-hospital-row">
                          <div className="dr-profile-box">{profileData.dtr_academic_job_position}</div>
                        </div>

                        <h5 className="dr-profile-sub-title mt-4">
                          <FaCheckCircle className="dr-profile-check-icon" />My Administrative and Leadership Job Position
                        </h5>
                        <div className="dr-hospital-row">
                          <div className="dr-profile-box">{profileData.dtr_administrative_leadership_job_position}</div>
                        </div>

                        <h5 className="dr-profile-sub-title mt-4">
                          <FaCheckCircle className="dr-profile-check-icon" />Job Type
                        </h5>
                        <div className="dr-hospital-row">
                          <div className="dr-profile-box">{profileData.job_type}</div>
                        </div>

                        <h5 className="dr-profile-sub-title mt-4">
                          <FaCheckCircle className="dr-profile-check-icon" />Current work status
                        </h5>
                        <div className="dr-hospital-row">
                          <div className="dr-profile-box">{profileData.current_work_status}</div>
                        </div>

                        <h5 className="dr-profile-sub-title mt-4">
                          <FaCheckCircle className="dr-profile-check-icon" />Visa Type
                        </h5>
                        <div className="dr-hospital-row">
                          <div className="dr-profile-box">{profileData.visa_type}</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Divider */}
                  <hr className="profile-divider" />

                  {/* Job Preference Section */}
                  <div className="dr-profile-card p-3">

                    <div className="dr-profile-header mt-1">
                      <FaBriefcase size={37} className="dr-profile-icon" />
                      <span className="dr-profile-title">Previous experience</span>
                    </div>

                    <h5 className="dr-profile-sub-title mt-4" style={{ marginLeft: '20px' }}>
                      <FaCheckCircle className="dr-profile-check-icon" /> Country have worked before
                    </h5>
                    <div className="dr-hospital-row" style={{ marginLeft: '20px' }}>
                      {profileData.dtr_before_worked_country?.map((country, index) => (
                        <div key={index} className="dr-profile-box">{country}</div>
                      ))}
                    </div>

                    <h5 className="dr-profile-sub-title mt-4" style={{ marginLeft: '20px' }}>
                      <FaCheckCircle className="dr-profile-check-icon" /> Reference letter from your previous employer
                    </h5>
                    <div className="dr-hospital-row ">
                      <div className="dr-profile-box" style={{ marginLeft: '20px' }}>{profileData.reference_letter ? "Yes" : "No"}</div>
                    </div>

                    <h5 className="dr-profile-sub-title mt-4" style={{ marginLeft: '20px' }}>
                      <FaCheckCircle className="dr-profile-check-icon" /> Passport
                    </h5>
                    <div className="dr-hospital-row ">
                      <div className="dr-profile-box" style={{ marginLeft: '20px' }}>
                        {profileData.dtr_valid_passport ? "Yes, I have Passport" : "No"}
                      </div>
                    </div>

                    <div className="dr-profile-header">
                      <FaLaptop size={37} className="dr-profile-icon" />
                      <span className="dr-profile-title">My preference for job</span>
                    </div>

                    <div className="dr-profile-card-body text-center">
                      <h5 className="dr-profile-sub-title mt-4">
                        <FaCheckCircle className="dr-profile-check-icon" />Job position I am applying for
                      </h5>
                      <div className="dr-hospital-row ">
                        <div className="dr-profile-box">{profileData.dtr_job_position_for_applying}</div>
                      </div>

                      <h5 className="dr-profile-sub-title mt-4">
                        <FaCheckCircle className="dr-profile-check-icon" /> Prefer job Location
                      </h5>
                      <div className="dr-hospital-row ">
                        {profileData.dtr_preferred_job_location?.map((location, index) => (
                          <div key={index} className="dr-profile-box">{location}</div>
                        ))}
                      </div>

                      <h5 className="dr-profile-sub-title mt-4">
                        <FaCheckCircle className="dr-profile-check-icon" /> My Expectation
                      </h5>

                      <div className="dr-hospital-row ">
                        <div className="dr-profile-box text-center">
                          <div className="dr-profile-item ">
                            <span>
                              Salary - {parseFloat(profileData.dtr_min_monthly_sal).toString().replace(/\.0+$/, "")} -
                              {parseFloat(profileData.dtr_max_monthly_sal).toString().replace(/\.0+$/, "")}{" "}
                              {profileData.dtr_country_currency}
                            </span>

                          </div>
                          <div className="dr-profile-item ">
                            <span className="dr-profile-dot"></span>
                            <span>Day Off - {profileData.dtr_day_off_preference}</span>
                          </div>
                          <div className="dr-profile-item ">
                            <span className="dr-profile-dot"></span>
                            <span>Accommodation - {profileData.dtr_accommodation_preference}</span>
                          </div>
                        </div>
                      </div>

                      <h5 className="dr-profile-sub-title mt-4">
                        <FaCheckCircle className="dr-profile-check-icon" />I would like to start my job
                      </h5>
                      <div className="dr-hospital-row ">
                        <div className="dr-profile-box">{new Date(profileData.dtr_job_start_date).toLocaleDateString()}</div>
                      </div>


                      {/* Contact Details Section - Gold Plan Only */}
                      <div className="dr-profile-card p-3 mb-4" style={{ marginTop: '20px' }}>
                        <div className="dr-profile-header-contact-heading-dr">
                          <FaPhoneAlt size={32} className="dr-profile-icon" />
                          <span className="dr-profile-title">Contact Details</span>
                        </div>

                        <div className="dr-profile-card-body text-center">
                          <div className="candidate-view-content-wrapper-emp employer-candidate-viewdetails-contactdetails">
                            {isUnlocked ? (
                              <div className="d-flex flex-column align-items-center">
                                {profileData?.source?.toLowerCase() === 'agency' && agencyContactDetails ? (
                                  <>
                                    <div className="dr-profile-info">
                                      <div className="info-row">
                                        <FaBuilding size={28} color="#0078d7" />
                                        <span><strong>Agency Name:</strong> {agencyContactDetails.agency_name || "Not provided"}</span>
                                      </div>
                                      <div className="info-row">
                                        <FaPhoneAlt size={28} color="#007bff" />
                                        <span><strong>Phone Number:</strong> {agencyContactDetails.official_phone || agencyContactDetails.phone || "Not provided"}</span>
                                      </div>
                                      <div className="info-row">
                                        <FaEnvelope size={28} color="#0078d7" />
                                        <span><strong>Agency Email:</strong> {agencyContactDetails.email || "Not provided"}</span>
                                      </div>
                                      <div className="info-row" style={{ cursor: 'pointer' }} onClick={() => navigate(`/agencyprofile/${profileData.agency_uid}`)}>
                                        <FaUser size={28} color="#007bff" />
                                        <span style={{ textDecoration: 'underline', color: '#007bff' }}>View Agency Profile</span>
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <div className="dr-profile-info-contact">
                                      <div className="info-row">
                                        <FaPhoneAlt size={28} color="#007bff" />
                                        <span><strong>Phone:</strong> {formatContactWithCode(profileData.mobile_number_country_code, profileData.phone_number || profileData.mobile_number || profileData.whatsapp_number)}</span>
                                      </div>
                                      {profileData.whatsapp_number && (
                                        <div className="info-row">
                                          <FaWhatsapp size={28} color="#25D366" />
                                          <span><strong>WhatsApp:</strong> {formatContactWithCode(profileData.whatsapp_country_code, profileData.whatsapp_number)}</span>
                                        </div>
                                      )}
                                      <div className="info-row">
                                        <FaEnvelope size={28} color="#0078d7" />
                                        <span><strong>Email:</strong> {profileData.email_id || profileData.email || "Not provided"}</span>
                                      </div>
                                      {profileData.telegram_number && (
                                        <div className="info-row">
                                          <FaTelegramPlane size={28} color="#0088cc" />
                                          <span><strong>Telegram:</strong> {formatContactWithCode(profileData.telegram_country_code, profileData.telegram_number)}</span>
                                        </div>
                                      )}
                                    </div>
                                  </>
                                )}
                              </div>
                            ) : (
                              <div className="d-flex flex-column align-items-center">
                                {profileData?.source?.toLowerCase() === 'agency' ? (
                                  <>
                                    <div className="dr-profile-info">
                                      <div className="info-row" onClick={handleUnlockContact} style={{ cursor: 'pointer' }}>
                                        <FaBuilding size={28} color="#0078d7" />
                                        <span><strong>Agency Name (Click to Reveal)</strong></span>
                                      </div>
                                      <div className="info-row" onClick={handleUnlockContact} style={{ cursor: 'pointer' }}>
                                        <FaPhoneAlt size={28} color="#007bff" />
                                        <span><strong>Phone Number (Click to Reveal)</strong></span>
                                      </div>
                                      <div className="info-row" onClick={handleUnlockContact} style={{ cursor: 'pointer' }}>
                                        <FaEnvelope size={28} color="#0078d7" />
                                        <span><strong>Agency Email (Click to Reveal)</strong></span>
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <div className="dr-profile-info-contact">
                                      <div className="info-row" onClick={handleUnlockContact} style={{ cursor: 'pointer' }}>
                                        <FaPhoneAlt size={28} color="#007bff" />
                                        <span><strong>Phone Number (Click to Reveal)</strong></span>
                                      </div>
                                      <div className="info-row" onClick={handleUnlockContact} style={{ cursor: 'pointer' }}>
                                        <FaWhatsapp size={28} color="#25D366" />
                                        <span><strong>WhatsApp (Click to Reveal)</strong></span>
                                      </div>
                                      <div className="info-row" onClick={handleUnlockContact} style={{ cursor: 'pointer' }}>
                                        <FaTelegramPlane size={28} color="#0088cc" />
                                        <span><strong>Telegram (Click to Reveal)</strong></span>
                                      </div>
                                      <div className="info-row" onClick={handleUnlockContact} style={{ cursor: 'pointer' }}>
                                        <FaEnvelope size={28} color="#0078d7" />
                                        <span><strong>Email (Click to Reveal)</strong></span>
                                      </div>
                                    </div>
                                  </>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>


                      <div className="text-center">
                        <h5 className="dr-profile-title-aboutme mt-4">About Me</h5>
                        <div className="dr-profile-aboutme-box mx-auto">
                          <p>{profileData.dtr_resume_description || profileData.resume_description || 'No description provided'}</p>
                        </div>
                        <div className="dr-profile-report reporting-font-styling">Report about this post</div>
                      </div>
                    </div>
                  </div>

                </div> {/* END OF CARD WRAPPER */}
              </Col>

              {/* Related Candidates Section for Doctor Profile */}
              <Col md={4} className="px-3 mb-4 mt-4">
                <div className="related-candidates-sidebar">
                  <h3 className="mb-4 related-candidates-title">Related Candidates</h3>
                  {relatedCandidates.length === 0 ? (
                    <div className="text-center no-jobs-message">No related candidates found</div>
                  ) : (
                    <div className="related-candidates-container">
                      {relatedCandidates.map((candidate) => (
                        <div key={candidate.user_id} className="related-candidate-card">
                        <CandidateCard
                          candidate={candidate}
                          onViewClick={() =>
                            handleViewClick(candidate.user_id, candidate.first_name)
                          }
                          onMessageClick={() => handleMessageClick(candidate)}
                          onVideoLoginPrompt={handleContactClick}
                        />
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </Container >
        </div >
      ) : (
        <Container className="p-0 candidate-view-container" style={{ marginTop: '100px' }}>
          <Row className="mx-0">
            <Col md={8} className="px-3 mb-4">
              <div className="combined-profile-details-card bg-white shadow rounded-4">
                {/* Divider */}
                <hr className="profile-divider" />

                {/* Second Profile Section */}
                <div className="profile-section p-3">
                  {/* Top Tags */}
                  <div className='bg-light'>
                    {user && String(user.id) === String(userId) && (
                      <div className="d-flex justify-content-center align-items-center flex-wrap px-3 pt-3">
                        <Button variant="outline-primary" onClick={handleDashboard} className="me-3 mb-2 px-4 shadow-sm">
                          <FaHome className="me-2" /> Dashboard
                        </Button>
                        <Button variant="primary" onClick={() => navigate('/personalinfo')} className="me-3 mb-2 px-4 shadow-sm">
                          <FaUser className="me-2" /> Edit Profile
                        </Button>
                        <Button variant="info" onClick={() => navigate('/choosephoto', { state: { userId, fromProfile: true } })} className="me-3 mb-2 px-4 shadow-sm text-white">
                          <FaCamera className="me-2" /> Upload Photo
                        </Button>
                        <Button variant="outline-success" onClick={() => navigate('/viewjobs')} className="mb-2 px-4 shadow-sm">
                          <FaBriefcase className="me-2" /> View Job Postings
                        </Button>
                      </div>
                    )}

                    <div className="d-flex justify-content-between mb-2">
                      {["agency", "agency_admin"].includes(user.role?.toLowerCase()) && (
                        <Button
                          variant={isShortlisted ? "secondary" : "warning"}
                          size="sm"
                          className="ms-2 px-3 fw-bold shadow-sm"
                          onClick={handleShortlist}
                          disabled={shortlisting || isShortlisted}
                        >
                          <FaRegHeart className="me-1" /> {isShortlisted ? "Shortlisted" : "Shortlist"}
                        </Button>
                      )}
                    </div>

                    {/* Profile Image */}
                    <div className="profile-img-wrapper position-relative mx-auto mb-3">
                      {profileData.profile_photo ? (
                        <img
                          src={profileData.profile_photo}
                          alt="Profile"
                          className="profile-img rounded-circle"
                          style={{ width: '150px', height: '150px', objectFit: 'cover', objectPosition: 'center center' }}
                        />
                      ) : (
                        <div
                          className="profile-img rounded-circle d-flex align-items-center justify-content-center bg-light overflow-hidden"
                          style={{ width: '150px', height: '150px' }}
                        >
                          <FaUserCircle size={150} color="#b8c0d6" style={{ display: 'block' }} />
                        </div>
                      )}
                    </div>

                    {/* Bottom Tags */}
                    <div className="d-flex justify-content-between px-3 mb-2">
                      <span className="profile-label-green">Gulf Exp.</span>
                      <span className="profile-label-green">{profileData.accommodation_preference}</span>
                    </div>
                  </div>

                  {/* Info Section */}
                  <div className="profile-info bg-light p-3 rounded-3">
                    <h6 className="fw-bold mb-3">
                      {profileData.first_name.split('@')[0]}, {profileData.age} Years
                    </h6>
                    {isNurseRole && isHospitalOrHealthcareCategory && (
                      <p className="mb-1 nursing-license-highlight">
                        Nursing License - {nursingLicenseDisplay || 'Not specified'}
                      </p>
                    )}
                    {/* <br /> */}
                    <p className="mb-1">Nationality - {profileData.nationality || 'Not specified'}</p>
                    <p className="mb-1" style={{ color: "green" }}>Current Location - {profileData.current_country}</p>
                    <p className="mb-1">Apply for - {formatApplyForCountry(profileData.country_apply_for_job)}</p>
                    <p className="mb-0">Total Experience - {profileData.total_work_experience === 'Fresher (0 Year)' || profileData.total_work_experience === '0' || profileData.total_work_experience === 0 ? 'Fresher' : profileData.total_work_experience}</p>
                  </div>
                </div>

                {/* Divider */}
                <hr className="profile-divider" />

                {/* Cook Details Section */}
                <div className="cook-details-section p-3">
                  {/* Section: Cook Info - Only show if there's cook info */}
                  {(profileData.gender || profileData.religion || profileData.marital_status ||
                    profileData.nationality || (education && education.length > 0) ||
                    (languages && languages.length > 0) || profileData.total_work_experience) && (
                      <div className=" desktop-section candidate-view-desktop-center">
                        <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                          <FaUser size={20} className="me-2" />
                          <span className="ms-2">Personal Information</span>
                        </h6>
                        <div className="cook-info-box candidate-view-content-wrapper-emp candidate-view-skill-info">
                          <ul className="list-group list-group-flush candidate-view-skill-info">
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Category - {getDisplayCategory(profileData)}
                            </li>
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Job Position - {
                                (() => {
                                  try {
                                    const jp = typeof profileData.job_position === 'string' && profileData.job_position.startsWith('[')
                                      ? JSON.parse(profileData.job_position)
                                      : profileData.job_position;
                                    return Array.isArray(jp) ? jp.join(', ') : (jp || 'Not specified');
                                  } catch (e) {
                                    return profileData.job_position || 'Not specified';
                                  }
                                })()
                              }
                            </li>
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Gender - {profileData.gender}
                            </li>
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Religion - {profileData.religion}
                            </li>
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Marital Status - {profileData.marital_status}
                            </li>
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Qualification - {education[0]?.level || 'Not specified'}
                            </li>
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Language - {languages.map(lang => lang.language).join(', ')}
                            </li>
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Experience - {profileData.total_work_experience === 'Fresher (0 Year)' || profileData.total_work_experience === '0' || profileData.total_work_experience === 0 ? 'Fresher' : profileData.total_work_experience || 'Not specified'}
                            </li>
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Height - {profileData.height || 'Not specified'}
                            </li>
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Weight - {profileData.weight || 'Not specified'}
                            </li>
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Color - {profileData.color || 'Not specified'}
                            </li>
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Apply for - {formatApplyForCountry(profileData.country_apply_for_job)}
                            </li>
                          </ul>
                        </div>
                      </div>
                    )}

                  {/* Language Sections - Only show if there are languages */}
                  {/* Language Sections - Only show if there are languages */}
                  {languages && languages.length > 0 && languages.map((lang, idx) => (
                    (lang.language || lang.speaking_level || lang.can_read || lang.can_write) && (
                      <div className="mb-3 desktop-section candidate-view-desktop-center" key={idx}>
                        <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                          <FaLanguage size={20} className="me-2" />
                          <span className="ms-2">{lang.language} Language</span>
                        </h6>
                        <div className="d-flex flex-wrap gap-2 mt-3 candidate-view-content-wrapper-emp candidate-view-tags-container employer-candidate-viewdetails">
                          {lang.speaking_level && <span className="language-tag">Speak: {lang.speaking_level}</span>}
                          {lang.can_read && <span className="language-tag">Read</span>}
                          {lang.can_write && <span className="language-tag">Write</span>}
                        </div>
                      </div>
                    )
                  ))}

                  {/* Section: Main Skills - Only show if there are main skills */}
                  <div className="mb-3 desktop-section candidate-view-desktop-center">
                    <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                      <FaCogs size={20} className="me-2" />
                      <span className="ms-2">Main Skills</span>
                    </h6>
                    <div className="d-flex flex-wrap gap-2 mt-3 candidate-view-content-wrapper-emp candidate-view-tags-container employer-candidate-viewdetails">
                      {mainSkills && mainSkills.length > 0 ? (
                        mainSkills.map((skill, index) => (
                          <span key={index} className="skill-tag">{skill}</span>
                        ))
                      ) : (
                        <div style={{ backgroundColor: '#f8f9fa', padding: '10px 15px', borderRadius: '0px', width: '100%' }}>
                          <span style={{ color: '#28a745' }}>•</span> Main skill : Not specified
                        </div>
                      )}
                    </div>
                  </div>

                  {hasSoftwareItDetails && (
                    <div className="mb-3 desktop-section candidate-view-desktop-center">
                      <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                        <FaLaptop size={20} className="me-2" />
                        <span className="ms-2">Software / IT Details</span>
                      </h6>
                      <div className="cook-info-box candidate-view-content-wrapper-emp candidate-view-skill-info">
                        <ul className="list-group list-group-flush candidate-view-skill-info">
                          {formatSoftwareItDisplay(softwareItProgrammingLanguages, softwareItOtherProgrammingLanguage).length > 0 && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Programming Languages: {formatSoftwareItDisplay(softwareItProgrammingLanguages, softwareItOtherProgrammingLanguage).join(', ')}
                            </li>
                          )}
                          {softwareItFrameworks.length > 0 && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Frameworks / Technologies: {softwareItFrameworks.join(', ')}
                            </li>
                          )}
                          {softwareItDatabaseSkills.length > 0 && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Database Skills: {softwareItDatabaseSkills.join(', ')}
                            </li>
                          )}
                          {softwareItOtherSkills.length > 0 && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Other Skills: {softwareItOtherSkills.join(', ')}
                            </li>
                          )}
                          {formatSoftwareItDisplay(softwareItCertifications, softwareItOtherCertification).length > 0 && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Certifications: {formatSoftwareItDisplay(softwareItCertifications, softwareItOtherCertification).join(', ')}
                            </li>
                          )}
                        </ul>
                      </div>
                    </div>
                  )}

                  {/* Section: Welder Details */}
                  {isWelderRole && hasWelderDetails && (
                    <div className="mb-3 desktop-section candidate-view-desktop-center">
                      <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                        <FaCogs size={20} className="me-2" />
                        <span className="ms-2">Technical Details</span>
                      </h6>
                      <div className="cook-info-box candidate-view-content-wrapper-emp candidate-view-skill-info">
                        <ul className="list-group list-group-flush candidate-view-skill-info">

                          {profileData.industry && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Industry Details: {profileData.industry === 'Others' ? profileData.other_industry : profileData.industry}
                            </li>
                          )}

                          {welderWeldingProcess.length > 0 && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Welding Process: {welderWeldingProcess.join(', ')}
                            </li>
                          )}

                          {welderWeldingPositions.length > 0 && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Welding Positions: {welderWeldingPositions.join(', ')}
                            </li>
                          )}

                          {welderMaterialExperience.length > 0 && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Material Experience: {welderMaterialExperience.join(', ')}
                            </li>
                          )}

                          {welderThicknessWorkedOn.length > 0 && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Thickness Worked On: {welderThicknessWorkedOn.join(', ')}
                            </li>
                          )}

                          {welderTechnicalKnowledge.length > 0 && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Technical Knowledge: {welderTechnicalKnowledge.join(', ')}
                            </li>
                          )}

                          {profileData.iti_trade_certificate && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> ITI / Trade Certificate: {profileData.iti_trade_certificate}
                            </li>
                          )}

                          {profileData.welding_certificate && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Welding Certificate: {profileData.welding_certificate}
                            </li>
                          )}

                          {profileData.welding_certificate_type && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Certificate Type: {profileData.welding_certificate_type}
                            </li>
                          )}

                          {profileData.passed_trade_test && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Have you passed any trade test before?: {profileData.passed_trade_test}
                            </li>
                          )}

                          {profileData.ready_for_trade_test && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Ready for trade test?: {profileData.ready_for_trade_test}
                            </li>
                          )}

                        </ul>
                      </div>
                    </div>
                  )}

                  {/* Section: Fabricator & Pipe Fitter Details */}
                  {isFabricatorPipeFitterRole && hasFabricatorDetails && (
                    <div className="mb-3 desktop-section candidate-view-desktop-center">
                      <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                        <FaCogs size={20} className="me-2" />
                        <span className="ms-2">Technical Details</span>
                      </h6>
                      <div className="cook-info-box candidate-view-content-wrapper-emp candidate-view-skill-info">
                        <ul className="list-group list-group-flush candidate-view-skill-info">

                          {profileData.industry && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Industry Details: {profileData.industry === 'Others' ? profileData.other_industry : profileData.industry}
                            </li>
                          )}

                          {fabricatorTechnicalSkills.length > 0 && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Technical Skills: {fabricatorTechnicalSkills.join(', ')}
                            </li>
                          )}

                          {fabricatorToolsKnowledge.length > 0 && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Tools & Equipment Knowledge: {fabricatorToolsKnowledge.join(', ')}
                            </li>
                          )}

                          {profileData.iti_trade_certificate && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> ITI / Trade Certificate: {profileData.iti_trade_certificate}
                            </li>
                          )}

                          {profileData.passed_trade_test && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Have you passed any trade test before?: {profileData.passed_trade_test}
                            </li>
                          )}

                        </ul>
                      </div>
                    </div>
                  )}

                  {/* Section: AC & HVAC Technician Details */}
                  {isACTechnicianRole && hasACTechnicianDetails && (
                    <div className="mb-3 desktop-section candidate-view-desktop-center">
                      <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                        <FaCogs size={20} className="me-2" />
                        <span className="ms-2">Technical Details</span>
                      </h6>
                      <div className="cook-info-box candidate-view-content-wrapper-emp candidate-view-skill-info">
                        <ul className="list-group list-group-flush candidate-view-skill-info">

                          {acSystems.length > 0 && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Air Conditioning Systems: {acSystems.join(', ')}
                            </li>
                          )}

                          {hvacSystems.length > 0 && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> HVAC Systems: {hvacSystems.join(', ')}
                            </li>
                          )}

                          {acTechnicalSkills.length > 0 && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Technical Skills: {acTechnicalSkills.join(', ')}
                            </li>
                          )}

                          {acToolsKnowledge.length > 0 && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Tools & Equipment Knowledge: {acToolsKnowledge.join(', ')}
                            </li>
                          )}

                        </ul>
                      </div>
                    </div>
                  )}

                  {/* Section: Chiller Technician Details */}
                  {isChillerTechnicianRole && hasChillerDetails && (
                    <div className="mb-3 desktop-section candidate-view-desktop-center">
                      <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                        <FaCogs size={20} className="me-2" />
                        <span className="ms-2">Chiller Technical Details</span>
                      </h6>
                      <div className="cook-info-box candidate-view-content-wrapper-emp candidate-view-skill-info">
                        <ul className="list-group list-group-flush candidate-view-skill-info">

                          {chillerType.length > 0 && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Chiller Type: {chillerType.join(', ')}
                            </li>
                          )}

                          {chillerSystemKnowledge.length > 0 && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> System Knowledge: {chillerSystemKnowledge.join(', ')}
                            </li>
                          )}

                          {chillerTechnicalSkills.length > 0 && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Technical Skills: {chillerTechnicalSkills.join(', ')}
                            </li>
                          )}

                          {chillerRefrigerantKnowledge.length > 0 && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Refrigerant Knowledge: {chillerRefrigerantKnowledge.join(', ')}
                            </li>
                          )}

                          {chillerToolsKnowledge.length > 0 && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Tools & Equipment: {chillerToolsKnowledge.join(', ')}
                            </li>
                          )}

                        </ul>
                      </div>
                    </div>
                  )}

                  {/* Section: Lathe & Milling Machine Details */}
                  {isLatheMachineRole && hasLatheDetails && (
                    <div className="mb-3 desktop-section candidate-view-desktop-center">
                      <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                        <FaCogs size={20} className="me-2" />
                        <span className="ms-2">Machine Operator Details</span>
                      </h6>
                      <div className="cook-info-box candidate-view-content-wrapper-emp candidate-view-skill-info">
                        <ul className="list-group list-group-flush candidate-view-skill-info">

                          {latheMachineKnowledge.length > 0 && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Lathe Machine Knowledge: {latheMachineKnowledge.join(', ')}
                            </li>
                          )}

                          {millingMachineKnowledge.length > 0 && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Milling Machine Knowledge: {millingMachineKnowledge.join(', ')}
                            </li>
                          )}

                          {latheTechnicalSkills.length > 0 && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Technical Skills: {latheTechnicalSkills.join(', ')}
                            </li>
                          )}

                          {latheMaterialExperience.length > 0 && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Material Experience: {latheMaterialExperience.join(', ')}
                            </li>
                          )}

                        </ul>
                      </div>
                    </div>
                  )}

                  {/* Section: Electrician Details */}
                  {isElectricianRole && hasElectricianDetails && (
                    <div className="mb-3 desktop-section candidate-view-desktop-center">
                      <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                        <FaCogs size={20} className="me-2" />
                        <span className="ms-2">Technical Details</span>
                      </h6>
                      <div className="cook-info-box candidate-view-content-wrapper-emp candidate-view-skill-info">
                        <ul className="list-group list-group-flush candidate-view-skill-info">

                          {profileData.electrician_industry_type && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Industry Experience: {profileData.electrician_industry_type === 'Other' ? profileData.other_electrician_industry : profileData.electrician_industry_type}
                            </li>
                          )}

                          {electricianElectricalExp.length > 0 && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Electrical Work Experience: {electricianElectricalExp.join(', ')}
                            </li>
                          )}

                          {electricianAutomation.length > 0 && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Automation & Controls: {electricianAutomation.join(', ')}
                            </li>
                          )}

                          {electricianDrawing.length > 0 && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Drawing & Testing: {electricianDrawing.join(', ')}
                            </li>
                          )}

                          {electricianVoltageExp.length > 0 && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Voltage Experience: {electricianVoltageExp.join(', ')}
                            </li>
                          )}

                          {profileData.max_voltage && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Maximum voltage worked on: {profileData.max_voltage}
                            </li>
                          )}

                          {profileData.iti_diploma_electrical && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> ITI / Diploma in Electrical: {profileData.iti_diploma_electrical}
                            </li>
                          )}

                          {profileData.electrical_license && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Electrical License: {profileData.electrical_license === 'Other' ? profileData.other_electrical_license : profileData.electrical_license}
                            </li>
                          )}

                          {profileData.electrical_trade_test_passed && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Trade Test Passed Before: {profileData.electrical_trade_test_passed}
                            </li>
                          )}

                          {profileData.electrical_ready_for_test && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Ready for Trade Test: {profileData.electrical_ready_for_test}
                            </li>
                          )}

                        </ul>
                      </div>
                    </div>
                  )}

                  {/* Section: Elevator Technician Details */}
                  {isElevatorTechnicianRole && hasElevatorDetails && (
                    <div className="mb-3 desktop-section candidate-view-desktop-center">
                      <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                        <FaCogs size={20} className="me-2" />
                        <span className="ms-2">Elevator Technician Details</span>
                      </h6>
                      <div className="cook-info-box candidate-view-content-wrapper-emp candidate-view-skill-info">
                        <ul className="list-group list-group-flush candidate-view-skill-info">

                          {elevatorFieldExperience.length > 0 && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Field Experience: {elevatorFieldExperience.join(', ')}
                            </li>
                          )}

                          {elevatorSystemKnowledge.length > 0 && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> System Knowledge: {elevatorSystemKnowledge.join(', ')}
                            </li>
                          )}

                          {elevatorControlExperience.length > 0 && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Control System Experience: {elevatorControlExperience.join(', ')}
                            </li>
                          )}

                          {elevatorBrandExperience.length > 0 && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Brand Experience: {elevatorBrandExperience.join(', ')}
                            </li>
                          )}

                          {profileData.elevator_technical_diploma && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Technical Diploma / ITI: {profileData.elevator_technical_diploma}
                            </li>
                          )}

                          {profileData.elevator_safety_training && (
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Safety Training: {profileData.elevator_safety_training}
                            </li>
                          )}

                        </ul>
                      </div>
                    </div>
                  )}

                  {/* Section: CNC Machine Details */}
                  {(() => {
                    const safeParse = (v) => { try { return Array.isArray(v) ? v : (typeof v === 'string' ? JSON.parse(v) : []); } catch { return typeof v === 'string' && v ? [v] : []; } };

                    const cncOperatorPositions = safeParse(profileData.cnc_operator_position);
                    const industryExperience = safeParse(profileData.industry_experience);
                    const cncControls = safeParse(profileData.cnc_controls);
                    const machinesOperated = safeParse(profileData.machines_operated);
                    const cncMachines = safeParse(profileData.cnc_machines);
                    const technicalSkills = safeParse(profileData.technical_skills);
                    const softwareKnowledge = safeParse(profileData.software_knowledge);

                    const programmingType = profileData.programming_type;
                    const cadCamKnowledge = safeParse(profileData.cad_cam_knowledge);
                    const jobSkillsChecklist = safeParse(profileData.job_skills_checklist);

                    const hasCncData = cncOperatorPositions.length > 0 || industryExperience.length > 0 || cncControls.length > 0 || machinesOperated.length > 0 || cncMachines.length > 0 || technicalSkills.length > 0 || softwareKnowledge.length > 0 || programmingType || cadCamKnowledge.length > 0 || profileData.read_engineering_drawings || profileData.gdt_knowledge || profileData.tool_setting_offsets || jobSkillsChecklist.length > 0;

                    if (!hasCncData) return null;

                    return (
                      <div className="mb-3 desktop-section candidate-view-desktop-center">
                        <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                          <FaCogs size={20} className="me-2" />
                          <span className="ms-2">CNC Machine Details</span>
                        </h6>
                        <div className="cook-info-box candidate-view-content-wrapper-emp candidate-view-skill-info">
                          <ul className="list-group list-group-flush candidate-view-skill-info">

                            {cncOperatorPositions.length > 0 && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> Position Applying For: {cncOperatorPositions.join(', ')}
                              </li>
                            )}

                            {industryExperience.length > 0 && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> Industry Experience: {industryExperience.join(', ')}
                              </li>
                            )}

                            {cncControls.length > 0 && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> CNC Controls: {cncControls.join(', ')}
                              </li>
                            )}

                            {(machinesOperated.length > 0 || cncMachines.length > 0) && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> Machines Operated: {Array.from(new Set([...machinesOperated, ...cncMachines])).join(', ')}
                              </li>
                            )}

                            {technicalSkills.length > 0 && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> Technical Skills: {technicalSkills.join(', ')}
                              </li>
                            )}

                            {softwareKnowledge.length > 0 && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> Software Knowledge: {softwareKnowledge.join(', ')}
                              </li>
                            )}

                            {programmingType && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> Programming Type: {programmingType}
                              </li>
                            )}

                            {cadCamKnowledge.length > 0 && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> CAD/CAM Knowledge: {cadCamKnowledge.join(', ')}
                              </li>
                            )}

                            {profileData.read_engineering_drawings && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> Read Engineering Drawings: {profileData.read_engineering_drawings}
                              </li>
                            )}

                            {profileData.gdt_knowledge && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> GD&T Knowledge: {profileData.gdt_knowledge}
                              </li>
                            )}

                            {profileData.tool_setting_offsets && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> Tool Setting & Offsets: {profileData.tool_setting_offsets}
                              </li>
                            )}

                            {jobSkillsChecklist.length > 0 && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> Job Skills Checklist: {jobSkillsChecklist.join(', ')}
                              </li>
                            )}

                          </ul>
                        </div>
                      </div>
                    );
                  })()}

                  {/* Section: Mechanic Details */}
                  {(() => {
                    const safeParse = (v) => { try { return Array.isArray(v) ? v : (typeof v === 'string' ? JSON.parse(v) : []); } catch { return typeof v === 'string' && v ? [v] : []; } };

                    const workedWith = safeParse(profileData.worked_with);
                    const mechanicSkills = safeParse(profileData.mechanic_skills);
                    const vehicleExperience = safeParse(profileData.vehicle_experience);

                    const hasMechanicData = workedWith.length > 0 || profileData.previous_company_name || mechanicSkills.length > 0 || vehicleExperience.length > 0 || profileData.diagnostic_scanner_use || profileData.read_wiring_diagrams || profileData.work_independently || profileData.mechanic_driving_license;

                    if (!hasMechanicData) return null;

                    return (
                      <div className="mb-3 desktop-section candidate-view-desktop-center">
                        <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                          <FaCogs size={20} className="me-2" />
                          <span className="ms-2">Mechanic Details</span>
                        </h6>
                        <div className="cook-info-box candidate-view-content-wrapper-emp candidate-view-skill-info">
                          <ul className="list-group list-group-flush candidate-view-skill-info">

                            {workedWith.length > 0 && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> Worked With: {workedWith.join(', ')}
                              </li>
                            )}

                            {profileData.previous_company_name && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> Previous Company Name: {profileData.previous_company_name}
                              </li>
                            )}

                            {mechanicSkills.length > 0 && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> Mechanic Skills: {mechanicSkills.join(', ')}
                              </li>
                            )}

                            {vehicleExperience.length > 0 && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> Vehicle Experience: {vehicleExperience.join(', ')}
                              </li>
                            )}

                            {profileData.diagnostic_scanner_use && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> Diagnostic Scanner Use: {profileData.diagnostic_scanner_use}
                              </li>
                            )}

                            {profileData.read_wiring_diagrams && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> Read Wiring Diagrams: {profileData.read_wiring_diagrams}
                              </li>
                            )}

                            {profileData.work_independently && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> Work Independently: {profileData.work_independently}
                              </li>
                            )}

                            {profileData.mechanic_driving_license && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> Driving License: {profileData.mechanic_driving_license}
                              </li>
                            )}

                          </ul>
                        </div>
                      </div>
                    );
                  })()}


                  {/* Section: Cooking Skills - Only show if there are cook categories */}
                  {(() => {
                    const cookCategories = (() => { try { const v = profileData.cook_category; return Array.isArray(v) ? v : (typeof v === 'string' ? JSON.parse(v) : []); } catch { return []; } })();
                    if (cookCategories.length === 0) return null;
                    return (
                      <div className="mb-3 desktop-section candidate-view-desktop-center">
                        <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                          <FaUtensils size={20} className="me-2" />
                          <span className="ms-2">Cooking Skills</span>
                        </h6>
                        <div className="d-flex flex-wrap gap-2 mt-3 candidate-view-content-wrapper-emp candidate-view-tags-container employer-candidate-viewdetails">
                          {cookCategories.map((cat, idx) => (
                            <span key={idx} className="skill-tag">{cat}</span>
                          ))}
                        </div>
                      </div>
                    );
                  })()}

                  {/* Nurse Details Section - Only show for nurse job positions */}
                  {(() => {
                    const nurseKeywords = ['nurse', 'nursing'];
                    const jobPositions = (() => {
                      try {
                        const jp = profileData.job_position;
                        if (Array.isArray(jp)) return jp;
                        if (typeof jp === 'string' && jp.startsWith('[')) return JSON.parse(jp);
                        return jp ? [jp] : [];
                      } catch { return []; }
                    })();
                    const isNurse = jobPositions.some(p => nurseKeywords.some(k => p.toLowerCase().includes(k)));
                    if (!isNurse) return null;

                    const nursingQuals = (() => { try { const v = profileData.nursing_qualifications; return Array.isArray(v) ? v : (typeof v === 'string' ? JSON.parse(v) : []); } catch { return []; } })();
                    const professionalQuals = (() => { try { const v = profileData.professional_qualifications; return Array.isArray(v) ? v : (typeof v === 'string' ? JSON.parse(v) : []); } catch { return []; } })();
                    const specializedQuals = (() => { try { const v = profileData.specialized_qualifications; return Array.isArray(v) ? v : (typeof v === 'string' ? JSON.parse(v) : []); } catch { return []; } })();
                    const langQuals = (() => { try { const v = profileData.language_qualifications; return Array.isArray(v) ? v : (typeof v === 'string' ? JSON.parse(v) : []); } catch { return []; } })();
                    const culturalQuals = (() => { try { const v = profileData.cultural_adaptation_qualifications; return Array.isArray(v) ? v : (typeof v === 'string' ? JSON.parse(v) : []); } catch { return []; } })();
                    const nursingJobCountries = (() => { try { const v = profileData.nursing_job_countries; return Array.isArray(v) ? v : (typeof v === 'string' ? JSON.parse(v) : []); } catch { return []; } })();
                    const hasPrometric = profileData.has_prometric_certificate === true || profileData.has_prometric_certificate === 1;
                    const hasDataflow = profileData.has_dataflow_certificate === true || profileData.has_dataflow_certificate === 1;

                    return (
                      <div className="mb-3 desktop-section candidate-view-desktop-center">
                        <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                          <FaUserFriends size={20} className="me-2" />
                          <span className="ms-2">Nurse Details</span>
                        </h6>
                        <div className="cook-info-box candidate-view-content-wrapper-emp candidate-view-skill-info">
                          <ul className="list-group list-group-flush candidate-view-skill-info">

                            {/* Current Hospital */}
                            {profileData.current_hospital_name && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> Current Hospital: {profileData.current_hospital_name}
                                {profileData.current_hospital_country && ` (${profileData.current_hospital_country})`}
                              </li>
                            )}
                            {profileData.current_employment_date && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> Current Employment Period:{' '}
                                {new Date(profileData.current_employment_date).toLocaleDateString('en-US', { month: 'short', year: 'numeric' })}
                                {profileData.current_finish_contract_date && ` – ${new Date(profileData.current_finish_contract_date).toLocaleDateString('en-US', { month: 'short', year: 'numeric' })}`}
                              </li>
                            )}

                            {/* Previous Hospital */}
                            {profileData.previous_hospital_name && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> Previous Hospital: {profileData.previous_hospital_name}
                                {profileData.previous_hospital_country && ` (${profileData.previous_hospital_country})`}
                              </li>
                            )}
                            {profileData.previous_employment_date && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> Previous Employment Period:{' '}
                                {new Date(profileData.previous_employment_date).toLocaleDateString('en-US', { month: 'short', year: 'numeric' })}
                                {profileData.previous_finish_contract_date && ` – ${new Date(profileData.previous_finish_contract_date).toLocaleDateString('en-US', { month: 'short', year: 'numeric' })}`}
                              </li>
                            )}

                            {/* Nursing Academic Qualifications */}
                            {nursingQuals.length > 0 && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> Nursing Qualifications: {nursingQuals.join(', ')}
                              </li>
                            )}

                            {/* Professional Qualifications */}
                            {professionalQuals.length > 0 && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> Professional Qualifications: {professionalQuals.join(', ')}
                              </li>
                            )}

                            {/* Specialized Qualifications */}
                            {specializedQuals.length > 0 && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> Specialized Qualifications: {specializedQuals.join(', ')}
                              </li>
                            )}

                            {/* Language Qualifications */}
                            {langQuals.length > 0 && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> Language Qualifications: {langQuals.join(', ')}
                              </li>
                            )}


                            {/* Cultural Adaptation */}
                            {culturalQuals.length > 0 && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> Cultural Adaptation: {culturalQuals.join(', ')}
                              </li>
                            )}

                            {/* License / Exam Status */}
                            {profileData.nurse_license_status && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> License / Exam Status: {profileData.nurse_license_status}
                              </li>
                            )}

                            {/* Prometric Certificate */}
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Prometric Certificate: {hasPrometric ? 'Yes' : 'No'}
                              {hasPrometric && profileData.prometric_issue_date && (
                                <span className="ms-2 text-muted" style={{ fontSize: '0.85em' }}>
                                  (Issued: {new Date(profileData.prometric_issue_date).toLocaleDateString('en-US', { month: 'short', year: 'numeric' })}
                                  {profileData.prometric_expiry_date && ` – Expiry: ${new Date(profileData.prometric_expiry_date).toLocaleDateString('en-US', { month: 'short', year: 'numeric' })}`}
                                  {profileData.prometric_issued_country && `, ${profileData.prometric_issued_country}`})
                                </span>
                              )}
                            </li>

                            {/* Dataflow Certificate */}
                            <li className="list-group-item cook-info-item">
                              <span className="text-success">•</span> Dataflow Certificate: {hasDataflow ? 'Yes' : 'No'}
                            </li>

                            {/* Preferred Nursing Job Countries */}
                            {nursingJobCountries.length > 0 && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> Looking for nursing job in: {nursingJobCountries.join(', ')}
                              </li>
                            )}

                          </ul>
                        </div>
                      </div>
                    );
                  })()}

                  {/* Driver & Delivery Details Section - hide for nurses */}
                  {(drivingLicenseCountries.length > 0 || carTypes.length > 0 || bikeTypes.length > 0 ||
                    deliveryExpTypes.length > 0 || profileData.uses_google_maps || deliveryCompanyNames.length > 0) &&
                    !(() => { try { const jp = profileData.job_position; const arr = Array.isArray(jp) ? jp : (typeof jp === 'string' && jp.startsWith('[') ? JSON.parse(jp) : (jp ? [jp] : [])); return arr.some(p => ['nurse', 'nursing'].some(k => p.toLowerCase().includes(k))); } catch { return false; } })() && (
                      <div className="mb-3 desktop-section candidate-view-desktop-center">
                        <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                          <FaIdCard size={20} className="me-2" />
                          <span className="ms-2">Driver & Delivery Details</span>
                        </h6>
                        <div className="cook-info-box candidate-view-content-wrapper-emp candidate-view-skill-info">
                          <ul className="list-group list-group-flush candidate-view-skill-info">
                            {drivingLicenseCountries.length > 0 && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> Driving License: {
                                  (() => {
                                    const filtered = drivingLicenseCountries.filter(c => c && c !== "I don't have driving license" && c !== "I Don't have License" && c !== "Not Licensed");
                                    return filtered.length > 0 ? filtered.join(', ') : "Not Licensed";
                                  })()
                                }
                              </li>
                            )}

                            {carTypes.length > 0 && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> Car Types: {carTypes.join(', ')}
                              </li>
                            )}

                            {(previousCars.length > 0 || profileData.other_previous_car) && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> Previous Driven Cars: {[...previousCars, profileData.other_previous_car].filter(Boolean).join(', ')}
                              </li>
                            )}

                            {bikeTypes.length > 0 && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> Bike Types: {bikeTypes.join(', ')}
                              </li>
                            )}

                            {(previousBikes.length > 0 || profileData.other_previous_bike) && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> Previous Driven Bikes: {[...previousBikes, profileData.other_previous_bike].filter(Boolean).join(', ')}
                              </li>
                            )}

                            {profileData.bike_ownership_status && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> Bike Ownership: {profileData.bike_ownership_status}
                              </li>
                            )}

                            {(deliveryExpTypes.length > 0 || profileData.other_delivery_experience) && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> Delivery Experience: {[...deliveryExpTypes, profileData.other_delivery_experience].filter(Boolean).join(', ')}
                              </li>
                            )}

                            {profileData.uses_google_maps && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> Uses Google Maps: {profileData.uses_google_maps} {profileData.google_maps_experience_level ? `(${profileData.google_maps_experience_level})` : ''}
                              </li>
                            )}

                            {(otherDeliveryApps.length > 0 || profileData.other_navigation_apps) && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> Other Apps: {[...otherDeliveryApps, profileData.other_navigation_apps].filter(Boolean).join(', ')}
                              </li>
                            )}

                            {deliveryCompanyNames.length > 0 && (
                              <li className="list-group-item cook-info-item">
                                <span className="text-success">•</span> Delivery Companies: {deliveryCompanyNames.join(', ')}
                              </li>
                            )}
                          </ul>
                        </div>
                      </div>
                    )}
                  {/* </div> */}

                  {/* Divider - Only show if there's content in cook details section */}
                  {/* {(mainSkills && mainSkills.length > 0) ||
                  (languages && languages.length > 0) ||
                  (profileData.gender || profileData.religion || profileData.marital_status) ? (
                  <hr className="profile-divider" />
                ) : null} */}

                  {/* Skills and Experience Section */}
                  {/* <div className="skills-experience-section p-3"> */}
                  {/* Cooking Skills - Only show if there are cooking skills */}
                  {cookingSkills && cookingSkills.length > 0 && (
                    <div className="mb-3 desktop-section candidate-view-desktop-center">
                      <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                        <FaUtensils size={20} className="me-2" />
                        <span className="ms-2">Cooking Skills</span>
                      </h6>
                      <div className="d-flex flex-wrap gap-2 mt-3 candidate-view-content-wrapper-emp candidate-view-tags-container employer-candidate-viewdetails">
                        {cookingSkills.map((item, index) => (
                          <span key={index} className="skill-tag">{item}</span>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Other Skills - Only show if there are other skills */}
                  {otherSkills && otherSkills.length > 0 && (
                    <div className="mb-3 desktop-section candidate-view-desktop-center">
                      <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                        <FaStar size={20} className="me-2" />
                        <span className="ms-2">Other Skills</span>
                      </h6>
                      <div className="d-flex flex-wrap gap-2 mt-3 candidate-view-content-wrapper-emp candidate-view-tags-container employer-candidate-viewdetails">
                        {otherSkills.map((item, index) => (
                          <span key={index} className="skill-tag">{item}</span>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Personality - Only show if there are personality traits */}
                  {personality && personality.length > 0 && (
                    <div className="mb-3 desktop-section candidate-view-desktop-center">
                      <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                        <FaUserFriends size={20} className="me-2" />
                        <span className="ms-2">Personality</span>
                      </h6>
                      <div className="d-flex flex-wrap gap-2 mt-3 candidate-view-content-wrapper-emp candidate-view-tags-container employer-candidate-viewdetails">
                        {personality.map((trait, index) => (
                          <span key={index} className="skill-tag">{trait}</span>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Work Experience - Only show if there's work experience */}
                  {experience && experience.length > 0 && (
                    <div className="mb-3 desktop-section candidate-view-desktop-center">
                      <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                        <FaBriefcase size={20} className="me-2" />
                        <span className="ms-2">Work Experience</span>
                      </h6>

                      <div className="candidate-view-content-wrapper-emp employer-candidate-viewdetails-workexperience">
                        {experience.length > 0 ? (
                          experience.map((exp, expIdx) => {
                            const countryDisplay = Array.isArray(exp.country)
                              ? exp.country.join(', ')
                              : exp.country || '';
                            const jobPositionDisplay = Array.isArray(exp.job_position)
                              ? exp.job_position.join(', ')
                              : exp.job_position || '';
                            const dutiesDisplay = Array.isArray(exp.house_duties)
                              ? exp.house_duties.join(', ')
                              : exp.house_duties;

                            return (
                              <div className="bg-light p-3 rounded candidate-view-experience-item" key={expIdx}>
                                <ul className="mb-2 ps-3">
                                  <li>
                                    {exp.join_month || exp.join_year ? `${exp.join_month || ''} ${exp.join_year || ''}` : 'Experience period not specified'}
                                    {(exp.exit_month || exp.exit_year) && ` - ${exp.exit_month || ''} ${exp.exit_year || ''}`}
                                  </li>
                                  <li>{jobPositionDisplay} {countryDisplay}</li>
                                  {exp.employer_nationality && <li>{exp.employer_nationality} Family</li>}
                                  <li>Duties - {dutiesDisplay || 'Not specified'}</li>
                                </ul>
                              </div>
                            );
                          })
                        ) : (
                          <div className="bg-light p-3 rounded mt-3 candidate-view-experience-item">
                            <p>No work experience listed</p>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {/* </div> */}

                  {/* Divider - Only show if there's content in skills section */}
                  {(cookingSkills && cookingSkills.length > 0) ||
                    (otherSkills && otherSkills.length > 0) ||
                    (personality && personality.length > 0) ||
                    (experience && experience.length > 0) ? (
                    <hr className="profile-divider" />
                  ) : null}

                  {/* Salary Preference Section */}
                  {/* <div className="salary-preference-section p-3"> */}
                  {/* Accommodation - Only show if accommodation preference exists */}
                  {profileData.accommodation_preference && (

                    <div className="mb-4 desktop-section candidate-view-desktop-center">
                      <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                        <FaHome size={20} className="me-2" />
                        <span className="ms-2">Accommodation</span>
                      </h6>

                      <div className="d-flex flex-wrap gap-2 mt-3 candidate-view-content-wrapper-emp candidate-view-tags-container employer-candidate-viewdetails">
                        {(Array.isArray(profileData.accommodation_preference)
                          ? profileData.accommodation_preference
                          : profileData.accommodation_preference
                            ?.split(',')
                            .filter(Boolean)
                        )?.map((item, index) => (
                          <span key={index} className="skill-tag">
                            {item.trim()}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Day Off - Only show if day off preference exists */}
                  {profileData.day_off_preference && (
                    <div className="mb-4 desktop-section candidate-view-desktop-center">
                      <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                        <FaCalendarAlt size={20} className="me-2" />
                        <span className="ms-2">Day Off</span>
                      </h6>

                      <div className="d-flex flex-wrap gap-2 mt-3 candidate-view-content-wrapper-emp candidate-view-tags-container employer-candidate-viewdetails">
                        {(Array.isArray(profileData.day_off_preference)
                          ? profileData.day_off_preference
                          : profileData.day_off_preference
                            ?.split(',')
                            .filter(Boolean)
                        )?.map((item, index) => (
                          <span key={index} className="skill-tag">
                            {item.trim()}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Reason to change Job - Only show if current work status exists */}
                  {profileData.current_work_status && (

                    <div className="mb-4 desktop-section candidate-view-desktop-center">
                      <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                        <FaExchangeAlt size={20} className="me-2" />
                        <span className="ms-2">Reason to change the Job</span>
                      </h6>

                      <div className="d-flex flex-wrap gap-2 mt-3 candidate-view-content-wrapper-emp candidate-view-tags-container employer-candidate-viewdetails">
                        {(Array.isArray(profileData.current_work_status)
                          ? profileData.current_work_status
                          : profileData.current_work_status
                            ?.split(',')
                            .filter(Boolean)
                        )?.map((item, index) => (
                          <span key={index} className="skill-tag">
                            {item.trim()}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Preferred Location - Only show if there are preferred locations */}
                  {preferredLocations && preferredLocations.length > 0 && (
                    <div className="mb-4 desktop-section candidate-view-desktop-center">
                      <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                        <FaMapMarkerAlt size={20} className="me-2" />
                        <span className="ms-2">Prefer Location</span>
                      </h6>

                      <div className="d-flex flex-wrap gap-2 mt-3 candidate-view-content-wrapper-emp candidate-view-tags-container employer-candidate-viewdetails">
                        {(Array.isArray(preferredLocations)
                          ? preferredLocations
                          : preferredLocations?.split(',').filter(Boolean)
                        )?.map((loc, index) => (
                          <span key={index} className="skill-tag">
                            {loc.trim()}
                          </span>
                        ))}

                        {profileData.other_job_location && (
                          <span className="skill-tag">
                            {profileData.other_job_location}
                          </span>
                        )}
                      </div>
                    </div>
                  )}

                  {/* NOC/Transfer Letter - Only show if this field exists */}
                  {/* {profileData.noc_or_transfer_letter && (
                    <div className="mb-1">
                      <h6 className="fw-bold text-primary d-flex align-items-center">
                        <FaFileAlt size={20} className="me-2" /> 
                        <span className="ms-2">NOC letter / Transfer letter</span>
                      </h6>
                      <div className="custom-value-box px-3 py-2 bg-light rounded text-secondary mb-2">
                        {profileData.noc_or_transfer_letter === 'yes'
                          ? 'Yes, I have'
                          : 'No, I don’t have'}
                      </div>
                    </div>
                  )} */}
                  {/* </div> */}

                  {/* Divider - Only show if there's content in salary preference section */}
                  {/* {(profileData.accommodation_preference || 
                  profileData.day_off_preference || 
                  profileData.current_work_status || 
                  (preferredLocations && preferredLocations.length > 0) || 
                  profileData.noc_or_transfer_letter) ? (
                  <hr className="profile-divider" />
                ) : null} */}

                  {/* Profile Details Section */}
                  {/* <div className="profile-details-section p-3"> */}
                  {/* Visa Status - Only show if visa type exists */}
                  {profileData.visa_type && (
                    <div className="mb-4 desktop-section candidate-view-desktop-center">
                      <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                        <FaFileAlt size={20} className="me-2" />
                        <span className="ms-2">NOC letter / Transfer letter</span>
                      </h6>

                      <div className="d-flex flex-wrap gap-2 mt-3 candidate-view-content-wrapper-emp candidate-view-tags-container employer-candidate-viewdetails">
                        <span className="skill-tag">
                          {profileData.noc_or_transfer_letter ? 'Yes, I have' : 'No'}
                        </span>
                      </div>
                    </div>

                  )}

                  {/* Banned in Any Country - Always show */}
                  <div className="mb-4 desktop-section candidate-view-desktop-center">
                    <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                      <FaBan size={20} className="me-2" />
                      <span className="ms-2">Banned in Any Country</span>
                    </h6>
                    <div className="d-flex flex-wrap gap-2 mt-3 candidate-view-content-wrapper-emp candidate-view-tags-container employer-candidate-viewdetails">
                      <span className="skill-tag">
                        {profileData.is_ban === true || profileData.is_ban === 1 || profileData.is_ban === 'true'
                          ? 'Yes'
                          : 'No'}
                      </span>
                    </div>
                  </div>

                  {/* Salary Expectation - Only show if salary fields exist */}
                  {(profileData.expected_monthly_salary_currency || profileData.expected_monthly_salary_qar || profileData.expected_monthly_salary_usd) && (

                    <div className="mb-4 desktop-section candidate-view-desktop-center">
                      <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                        <FaMoneyBillAlt size={20} className="me-2" />
                        <span className="ms-2">My Salary Expectation</span>
                      </h6>

                      <div className="d-flex flex-wrap gap-3 mt-3 candidate-view-content-wrapper-emp candidate-view-tags-container employer-candidate-viewdetails">
                        {(() => {
                          // Get the raw values from the database
                          const salaryDisplay = getSalaryExpectationDisplay(profileData);

                          return (
                            <>
                              <span className="skill-tag">
                                {salaryDisplay.localLabel} - {salaryDisplay.localValue === 'Negotiable' ? 'Negotiable' : `${salaryDisplay.localValue} ${salaryDisplay.localLabel}`}
                              </span>

                              <span className="skill-tag">
                                USD - {salaryDisplay.usdValue}
                              </span>
                            </>
                          );

                          /* return (
                            <>
                              <span className="skill-tag">
                                {salaryDisplay.localLabel} - {salaryDisplay.localValue === 'Negotiable' ? 'Negotiable' : `${salaryDisplay.localValue} ${salaryDisplay.localLabel}`}
                              </span>

                              <span className="skill-tag">
                                USD - {salaryDisplay.usdValue}
                              </span>
                            </>
                          );

                          return (
                            <>
                              <span className="skill-tag">
                                Qatar – {qarFormatted === 'Negotiable' ? 'Negotiable' : `${qarFormatted} QR`}
                              </span>

                              <span className="skill-tag">
                                USD – {usdFormatted === 'Negotiable' ? 'Negotiable' : `$${usdFormatted}`}
                              </span>
                            </>
                          ); */
                        })()}
                      </div>
                    </div>
                  )}

                  {/* Contact Details Section - Always show but with conditional content */}
                  <div className="dr-profile-card p-3 mb-4">
                    <div className="dr-profile-header-contact-heading">
                      <FaPhoneAlt size={32} className="dr-profile-icon" />
                      <span className="dr-profile-title">Contact Details</span>
                    </div>

                    <div className="dr-profile-card-body text-center">
                      <div className="candidate-view-content-wrapper-emp employer-candidate-viewdetails-contactdetails">
                        {isUnlocked ? (
                          <div className="d-flex flex-column align-items-center">
                            {profileData?.source?.toLowerCase() === 'agency' && agencyContactDetails ? (
                              <>
                                <div className="dr-profile-info">
                                  <div className="info-row">
                                    <FaBuilding size={28} color="#0078d7" />
                                    <span><strong>Agency Name:</strong> {agencyContactDetails.agency_name || "Not provided"}</span>
                                  </div>
                                  <div className="info-row">
                                    <FaPhoneAlt size={28} color="#007bff" />
                                    <span><strong>Phone Number:</strong> {agencyContactDetails.official_phone || agencyContactDetails.phone || "Not provided"}</span>
                                  </div>
                                  <div className="info-row">
                                    <FaEnvelope size={28} color="#0078d7" />
                                    <span><strong>Agency Email:</strong> {agencyContactDetails.email || "Not provided"}</span>
                                  </div>
                                  <div className="info-row" style={{ cursor: 'pointer' }} onClick={() => navigate(`/agencyprofile/${profileData.agency_uid}`)}>
                                    <FaUser size={28} color="#007bff" />
                                    <span style={{ textDecoration: 'underline', color: '#007bff' }}>View Agency Profile</span>
                                  </div>
                                </div>
                              </>
                            ) : (
                              <>
                                <div className="dr-profile-info-contact-nrml">
                                    <div className="info-row">
                                      <FaPhoneAlt size={28} color="#007bff" />
                                      <span><strong>Phone:</strong> {formatContactWithCode(profileData.mobile_number_country_code, profileData.phone_number || profileData.mobile_number || profileData.whatsapp_number)}</span>
                                    </div>
                                    {profileData.whatsapp_number && (
                                      <div className="info-row">
                                        <FaWhatsapp size={28} color="#25D366" />
                                        <span><strong>WhatsApp:</strong> {formatContactWithCode(profileData.whatsapp_country_code, profileData.whatsapp_number)}</span>
                                      </div>
                                    )}
                                  <div className="info-row">
                                    <FaEnvelope size={28} color="#0078d7" />
                                    <span><strong>Email:</strong> {profileData.email_id || profileData.email || "Not provided"}</span>
                                  </div>
                                    {profileData.telegram_number && (
                                      <div className="info-row">
                                        <FaTelegramPlane size={28} color="#0088cc" />
                                        <span><strong>Telegram:</strong> {formatContactWithCode(profileData.telegram_country_code, profileData.telegram_number)}</span>
                                      </div>
                                    )}
                                </div>
                              </>
                            )}
                          </div>
                        ) : (
                          <div className="d-flex flex-column align-items-center">
                            {profileData?.source?.toLowerCase() === 'agency' ? (
                              <>
                                <div className="dr-profile-info">
                                  <div className="info-row" onClick={handleUnlockContact} style={{ cursor: 'pointer' }}>
                                    <FaBuilding size={28} color="#0078d7" />
                                    <span><strong>Agency Name (Click to Reveal)</strong></span>
                                  </div>
                                  <div className="info-row" onClick={handleUnlockContact} style={{ cursor: 'pointer' }}>
                                    <FaPhoneAlt size={28} color="#007bff" />
                                    <span><strong>Phone Number (Click to Reveal)</strong></span>
                                  </div>
                                  <div className="info-row" onClick={handleUnlockContact} style={{ cursor: 'pointer' }}>
                                    <FaEnvelope size={28} color="#0078d7" />
                                    <span><strong>Agency Email (Click to Reveal)</strong></span>
                                  </div>
                                </div>
                              </>
                            ) : (
                              <>
                                <div className="dr-profile-info-contact-nrml">
                                  <div className="info-row" onClick={handleUnlockContact} style={{ cursor: 'pointer' }}>
                                    <FaPhoneAlt size={28} color="#007bff" />
                                    <span><strong>Phone Number (Click to Reveal)</strong></span>
                                  </div>
                                  <div className="info-row" onClick={handleUnlockContact} style={{ cursor: 'pointer' }}>
                                    <FaWhatsapp size={28} color="#25D366" />
                                    <span><strong>WhatsApp (Click to Reveal)</strong></span>
                                  </div>
                                  <div className="info-row" onClick={handleUnlockContact} style={{ cursor: 'pointer' }}>
                                    <FaTelegramPlane size={28} color="#0088cc" />
                                    <span><strong>Telegram (Click to Reveal)</strong></span>
                                  </div>
                                  <div className="info-row" onClick={handleUnlockContact} style={{ cursor: 'pointer' }}>
                                    <FaEnvelope size={28} color="#0078d7" />
                                    <span><strong>Email (Click to Reveal)</strong></span>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* About Me - Only show if resume description exists */}
                  {profileData.resume_description && (
                    <div className="mb-4">
                      <h6 className="fw-bold text-primary d-flex align-items-center">
                        <FaInfoCircle size={20} className="me-2" />
                        <span className="ms-2">About Me</span>
                      </h6>
                      <div className="about-me-box p-2 border rounded">
                        {profileData.resume_description}
                      </div>
                    </div>
                  )}

                  {/* Buttons below About Me */}
                  <div className="d-flex justify-content-center align-items-center flex-wrap mb-4" style={{ gap: '10px' }}>
                    {user && String(user.id) === String(userId) && (
                      <>
                        <Button variant="outline-success" onClick={() => navigate('/viewjobs')} className="px-4 shadow-sm">
                          <FaBriefcase className="me-2" /> View Job Postings
                        </Button>
                        <Button variant="primary" onClick={() => navigate('/personalinfo')} className="px-4 shadow-sm">
                          <FaUser className="me-2" /> Edit Profile
                        </Button>
                        <Button variant="info" onClick={() => navigate('/choosephoto', { state: { userId, fromProfile: true } })} className="px-4 shadow-sm text-white">
                          <FaCamera className="me-2" /> Upload Photo
                        </Button>
                        <Button variant="outline-primary" onClick={handleDashboard} className="px-4 shadow-sm">
                          <FaHome className="me-2" /> Dashboard
                        </Button>
                      </>
                    )}
                  </div>

                  {/* YouTube Video Link - Only show if upload video exists */}
                  {profileData.upload_video && (
                    <div className="mb-3">
                      <h6 className="fw-bold text-primary d-flex align-items-center">
                        <FaGraduationCap size={20} className="me-2" />
                        <span className="ms-2">YouTube Video Link</span>
                      </h6>
                      <div className="badge-pill-container-youtube mx-4">
                        <a href={profileData.upload_video} target="_blank" rel="noopener noreferrer">
                          Click here to watch introduction video
                        </a>
                      </div>
                    </div>
                  )}

                  {/* Report Link - Always show */}
                  <div className="text-end">
                    <button
                      className="text-primary text-decoration-none border-0 bg-transparent reporting-font-styling"
                      onClick={toggleReportForm}
                    >
                      Report this candidate
                    </button>
                  </div>
                </div>

                {showReportForm && (
                  <div className="report-job-section p-3">
                    <div className="shadow p-4" style={{ width: '60%', marginLeft: '20%' }}>
                      <h5 className="mb-3 reporting-font-styling">Report this candidate</h5>

                      <form onSubmit={handleReportSubmit}>
                        <div className="mb-3">
                          <label htmlFor="email" className="form-label">
                            Your email address
                          </label>
                          <input
                            type="email"
                            className="form-control report-job-input"
                            id="email"
                            name="email"
                            value={reportData.email}
                            onChange={handleReportChange}
                            placeholder="Enter your email"
                            required
                          />
                        </div>

                        <div className="mb-3">
                          <label htmlFor="reason" className="form-label">
                            Reason for reporting
                          </label>
                          <select
                            className="form-select report-job-select"
                            id="reason"
                            name="reason"
                            value={reportData.reason}
                            onChange={handleReportChange}
                            required
                          >
                            <option value="">Please select</option>
                            <option value="Fraudulent">Fraudulent</option>
                            <option value="Misleading">Misleading</option>
                            <option value="Discriminatory">Discriminatory</option>
                            <option value="Other">Other</option>
                          </select>
                        </div>

                        <div className="mb-3">
                          <label htmlFor="details" className="form-label">
                            Please describe your issues with this candidate
                          </label>
                          <textarea
                            className="form-control report-job-textarea"
                            id="details"
                            name="details"
                            value={reportData.details}
                            onChange={handleReportChange}
                            rows="4"
                            required
                          ></textarea>
                        </div>

                        <div className="report-job-warning">
                          ⚠️ To help fast track investigation, please include here any other relevant details that prompted you to report this candidate as fraudulent / misleading / discriminatory.
                        </div>

                        <div className="d-flex flex-column my-5">
                          <button type="submit" className="btn btn-primary report-job-button mb-3 reporting-font-styling">
                            Report candidate
                          </button>

                          <button
                            type="button"
                            className="btn btn-link report-job-cancel "
                            onClick={toggleReportForm}
                          >
                            Cancel
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                )}
              </div>
            </Col>

            {/* Matching Candidates Section */}
            <Col md={4} className="px-3 mb-4 mt-0">
              <div className="related-candidates-sidebar">
                <h3 className="related-candidates-title matching-candidates-heading text-primary">Matching Candidates</h3>
                {(user?.id && (!user.plan_name || !['gold', 'silver'].includes(String(user.plan_name).toLowerCase()))) ? (
                  <div className="locked-matching-candidates-container position-relative">
                    <div className="blur-overlay d-flex flex-column align-items-center justify-content-center text-center p-4 rounded-4" style={{
                      position: 'absolute',
                      top: 0, left: 0, right: 0, bottom: 0,
                      backgroundColor: 'rgba(255, 255, 255, 0.7)',
                      backdropFilter: 'blur(8px)',
                      zIndex: 10,
                      border: '1px solid #ddd'
                    }}>
                      <h5 className="fw-bold mb-3">Priority Matching Locked</h5>
                      <p className="small mb-4 text-muted">To access matching candidates, upgrade your plan to Gold or Silver.</p>
                      <Button 
                        variant="primary" 
                        onClick={() => window.location.href = '/subscription'}
                        className="rounded-pill px-4 fw-bold"
                      >
                        Upgrade Now
                      </Button>
                    </div>
                    {/* Mock Blurred Content */}
                    {[1, 2, 3].map((i) => (
                      <div key={i} className="mb-3 opacity-25">
                         <div className="card p-3 shadow-sm border-0 rounded-4">
                            <div className="d-flex align-items-center gap-3">
                               <div className="rounded-circle bg-light" style={{width: '60px', height: '60px'}}></div>
                               <div className="flex-grow-1">
                                  <div className="bg-light h-25 w-75 mb-2"></div>
                                  <div className="bg-light h-25 w-50"></div>
                               </div>
                            </div>
                         </div>
                      </div>
                    ))}
                  </div>
                ) : relatedCandidates.length === 0 ? (
                  <div className="text-center no-jobs-message">No matching candidates found</div>
                ) : (
                  <div className="related-candidates-container">
                    {relatedCandidates.slice(0, 6).map((candidate) => (
                      <div key={candidate.user_id} className="related-candidate-card">
                        <CandidateCard
                          candidate={candidate}
                          onViewClick={() =>
                            handleViewClick(candidate.user_id, candidate.first_name)
                          }
                          onMessageClick={() => handleMessageClick(candidate)}
                          user={user}
                          navigate={navigate}
                          onVideoLoginPrompt={handleContactClick}
                        />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </Container >
      )}

      {/* Registration Popup */}
      {
        showRegisterPopup && (
          <div className="modal-backdrop" style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 1050,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
            <div className="modal-content" style={{
              backgroundColor: 'white',
              padding: '20px',
              borderRadius: '0px',
              maxWidth: '500px',
              width: '90%',
              maxHeight: '90vh',
              overflowY: 'auto'
            }}>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5>Gulf Worker</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeRegisterPopup}
                  aria-label="Close"
                ></button>
              </div>
              <Register onSuccess={closeRegisterPopup} />
            </div>
          </div>
        )
      }



      <Footer />
    </>
  );
};

// CandidateCard component for related candidates
function CandidateCard({ candidate, onViewClick, onMessageClick, onVideoLoginPrompt, user, navigate }) {
  const formatDate = (dateString) => {
    if (!dateString) return 'Not specified';
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };

  const getMainLanguage = () => {
    if (!candidate.language || candidate.language.length === 0) return 'Not specified';
    return `${candidate.language[0].language}`;
  };

  return (
    <Card
      className="h-100 shadow-sm related-candidate-card mb-3"
      onClick={onViewClick}
      style={{
        cursor: 'pointer',
        border: '1px solid #e0e0e0',
        transition: 'all 0.3s ease'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';
      }}
    >
      <Card.Body className="p-3">
        <div className="relatedcandidates-card-items flex-md-row align-items-start">
          {/* Left Section - Image and Badges */}
          <div className="text-center mb-3 mb-md-0 me-md-3" style={{ minWidth: '100px' }}>
            {/* Badges */}
            <div className="d-flex justify-content-center gap-1 mb-2">
              {Number(candidate.purchased_badge) === 1 && (
                <span
                  className="badge bg-success text-white px-2 py-1 verified-label"
                  style={{ fontSize: '10px' }}
                >
                  <span className="verified-label-icon">&#10003;</span>
                  <span>Verified</span>
                </span>
              )}
              {candidate.verification_status?.toLowerCase() !== "verified" &&
                candidate.created_at &&
                moment().diff(moment(candidate.created_at), "days") <= 7 && (
                  <span
                    className="badge bg-primary text-white px-2 py-1"
                    style={{ fontSize: '10px' }}
                  >
                    New
                  </span>
                )}
            </div>

            {/* Profile Image - Made larger */}
            <div className="position-relative mb-2">
              {hasVisibleOfferBadge(candidate) && (
                <div
                  className="position-absolute top-0 start-50 translate-middle badge bg-warning text-dark px-2 py-1"
                  style={{ fontSize: '0.6rem', zIndex: 1 }}
                >
                  {getVisibleOfferBadgeText(candidate)}
                </div>
              )}

              {/* Updated Profile Image with Fallback */}
              {candidate.profile_photo ? (
                <Image
                  src={candidate.profile_photo}
                  alt="profile"
                  roundedCircle
                  className="border"
                  style={{
                    width: '100px',
                    height: '100px',
                    objectFit: 'cover'
                  }}
                />
              ) : (
                <div
                  className="border rounded-circle d-flex align-items-center justify-content-center bg-light mx-auto"
                  style={{
                    width: '100px',
                    height: '100px'
                  }}
                >
                  <i className="bi bi-person-fill text-muted" style={{ fontSize: '2rem' }}></i>
                </div>
              )}
            </div>

            <div
              className={hasHighlightedSourceLabel(candidate) ? "text-success fw-bold" : "text-muted"}
              style={{ fontSize: '0.75rem' }}
            >
              {getVisibleSourceLabel(candidate)}
            </div>
          </div>

          {/* Right Section - Candidate Details */}
          <div className="flex-grow-1 w-100">
            <h6 className="fw-bold mb-2 text-dark text-md-start relatedcandidates-name" style={{ fontSize: '0.9rem', lineHeight: '1.2' }}>
              {candidate.first_name?.split('@')[0]} - {candidate.age} years -{' '}
              <span className="text-muted" style={{ fontSize: '10px' }}>{candidate.nationality}</span>
            </h6>

            <div className="candidate-details relatedcandidate-alldetails" style={{ justifyItems: 'flex-start' }}>
              <div className="detail-item mb-1">
                <strong style={{ fontSize: '10px' }}>Job Position:</strong>{' '}
                <span className="text-dark" style={{ fontSize: '10px' }}>
                  {Array.isArray(candidate.job_position)
                    ? candidate.job_position.join(', ').trim() || 'Not specified'
                    : (candidate.job_position || 'Not specified')}
                </span>
              </div>

              <div className="detail-item mb-1">
                <strong style={{ fontSize: '10px' }}>{candidate.religion || 'Not specified'}:</strong>{' '}
                <span className="text-dark" style={{ fontSize: '10px' }}>{candidate.marital_status || 'Not specified'}</span>
              </div>

              <div className="detail-item mb-1">
                <strong style={{ fontSize: '10px' }}>Salary:</strong>{' '}
                <span className="text-dark" style={{ fontSize: '10px' }}>
                  {candidate.expected_monthly_salary_usd
                    ? parseInt(candidate.expected_monthly_salary_usd)
                    : '0'} USD /{' '}
                  {candidate.expected_monthly_salary_qar
                    ? parseInt(candidate.expected_monthly_salary_qar)
                    : '0'} QAR
                </span>
              </div>

              <div className="detail-item mb-1">
                <strong style={{ fontSize: '10px' }}>Experience:</strong>{' '}
                <span className="text-dark" style={{ fontSize: '10px' }}>{candidate.total_work_experience || 'Not specified'}</span>
              </div>

              <div className="detail-item mb-1">
                <strong style={{ fontSize: '10px' }}>Language:</strong>{' '}
                <span className="text-dark" style={{ fontSize: '10px' }}>{getMainLanguage()}</span>
              </div>

              <div className="detail-item mb-1">
                <strong style={{ fontSize: '10px' }}>Available From:</strong>{' '}
                <span className="text-dark" style={{ fontSize: '10px' }}>
                  {candidate.available_from || candidate.preferred_start_date || 'Not specified'}
                </span>
              </div>

              <div className="detail-item mb-0">
                <strong style={{ fontSize: '10px' }}>Current Location:</strong>{' '}
                <span className="text-dark" style={{ fontSize: '10px' }}>{candidate.current_country || 'Not specified'}</span>
              </div>
            </div>

          </div>
        </div>
      </Card.Body>
    </Card>
  );
}

export default ViewCandidates;

